// btw-front/src/i18n/index.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  ko: {
    translation: {
      nav: {
        services: "솔루션",
        certbear: "SSL 솔루션",
        about: "회사소개",
        usecases: "활용 사례",
        process: "프로세스",
        results: "성과",
        contact: "문의",
        partner: "파트너",
        dashboard: "대시보드",
        admin: "관리자",
        adminSalesReps: "영업대표 관리",
        profile: "내 정보",
        notices: "공지사항",
        logout: "로그아웃",
        logoutDone: "로그아웃되었습니다.",
      },
      hero: {
        eyebrow: "BetweenSoft",
        title: "엔터프라이즈 운영을\n더 안전하고 단단하게",
        desc:
          "SSL 인증서 관리, 미들웨어 운영, API 안정화, 웹 시스템 구축까지.\n" +
          "비트윈소프트는 서비스 중단 리스크를 줄이고 운영 품질을 높이는 기술 파트너입니다.",
        cta1: "프로젝트 문의",
        cta2: "솔루션 보기",

        techTitle: "주요 기술 분야",
        version: "v1.2",

        m1Label: "보안 · 인증서",
        m1Value: "CertBear SSL 통합 관리",
        m1Hint: "수집 · 모니터링 · 갱신 자동화",

        m2Label: "엔터프라이즈 미들웨어",
        m2Value: "TmaxSoft 공식 파트너",
        m2Hint: "JEUS · WebtoB 구축/마이그레이션/운영",

        m3Label: "플랫폼 · 운영",
        m3Value: "API 설계 및 운영 고도화",
        m3Hint: "지표 기반 모니터링 · 성능 개선",

        workTitle: "대표 작업",

        w1: "SSL 인증서 통합관리",
        w2: "미들웨어 구축/운영",
        w3: "기업 홈페이지 리뉴얼",
        w4: "백오피스/관리자 시스템",
        w5: "API/서버 구축",

        note: "* 빠른 구축보다 안정적인 운영을 우선합니다.",
      },
      services: {
        note: "* 프로젝트 성격과 운영 환경에 따라 범위/구성은 유연하게 조정됩니다.",
        moreTitle: "특별 기술 지원",
        moreDesc: "핵심 솔루션과 함께, 운영 환경에 맞춰 폭넓게 지원하는 기술 영역입니다.",
        flagshipBadge: "주력",
        popover: {
          close: "닫기",
          keywords: "키워드",
          detailFallback: "상세 정보",
        },
        items: {
          certbear: {
            title: "certBear SSL 인증 솔루션",
            desc: "SSL/TLS 인증서 수집·모니터링·갱신을 통합 관리해 만료 사고와 보안 리스크를 예방합니다.",
            tags: ["SSL/TLS", "자동화", "대시보드"],
            extra: {
              headline: "주요 기능",
              bullets: [
                "인증서 만료 자동 알림",
                "갱신 자동화/워크플로우",
                "대시보드 기반 자산 관리",
              ],
            },
          },
          tmax: {
            title: "TMAXSOFT 공식 파트너",
            desc: "TMAX 제품 기반의 구축/운영 경험으로 안정적인 엔터프라이즈 환경을 지원합니다.\nJEUS, WebtoB 등 미들웨어 운영지원",
            tags: ["Enterprise", "Integration", "운영"],
            extra: {
              headline: "구축/운영 히스토리",
              bullets: [
                "엔터프라이즈 환경 구축/전환 경험",
                "장애 대응/성능 튜닝/운영 프로세스 수립",
                "통합 연동(SSO/인증/권한 등) 지원",
              ],
            },
          },
          netfunnel: {
            title: "STC Lab API NetFUNNEL",
            desc: "API 요청 트래픽을 실시간으로 제어/큐잉(Queuing)해 과부하를 방지하고, 업무 우선순위 기반으로 안정적인 처리를 지원합니다.",
            tags: ["Traffic Control", "Queuing", "Priority"],
            extra: {
              headline: "도입 효과",
              bullets: [
                "리소스 임계치 기반 통과/대기 판단으로 서버 다운 방지",
                "업무/클라이언트 우선순위 반영으로 QoS 보장",
                "API별 처리/대기 현황 모니터링으로 운영 가시성 확보",
              ],
            },
          },
          everpure: {
            title: "Everpure 구축 · 운영",
            desc: "스토리지 설계부터 도입, 마이그레이션, 운영 최적화까지 환경에 맞춰 지원합니다.",
            tags: ["Storage", "Migration", "Ops"],
            extra: {
              headline: "지원 범위",
              bullets: ["설계/도입/마이그레이션", "운영 표준화 및 최적화", "모니터링/성능 분석"],
            },
          },
          elastic: {
            title: "Elasticsearch",
            desc: "로그/검색/분석 파이프라인 설계와 클러스터 운영으로 빠르고 안정적인 검색 환경을 만듭니다.",
            tags: ["Search", "Observability", "Scale"],
            extra: {
              headline: "운영/구축",
              bullets: [
                "클러스터 설계 및 튜닝",
                "로그/검색 파이프라인 구성",
                "관측성(모니터링/알람) 연동",
              ],
            },
          },
          oss: {
            title: "오픈소스/미들웨어 기술지원",
            desc: "사내/대외 오픈소스 유지보수 및 기술지원, 기여 프로세스 정착까지 함께합니다.",
            tags: ["OpenSource", "Maintain", "Governance"],
            extra: {
              headline: "프로세스",
              bullets: [
                "오픈소스 사용/검증 정책 수립",
                "취약점 대응 및 버전 관리",
                "기여/리뷰 프로세스 정착",
              ],
            },
          },
          renewal: {
            title: "홈페이지 리뉴얼",
            desc: "브랜딩과 메시지를 정리하고, 반응형·성능·SEO를 고려해 신뢰감 있는 웹을 만듭니다.",
            tags: ["UI/UX", "SEO", "Performance"],
            extra: {
              headline: "개선 포인트",
              bullets: ["콘텐츠/정보 구조 정리", "반응형 UI/UX 개선", "성능/SEO 최적화"],
            },
          },
        },
      },
      certbear: {
        badge: "SSL 인증 솔루션",
        title: "CertBear — 인증서 발급·갱신을 더 쉽고 안전하게",
        desc: "CertBear는 SSL 인증서 라이프사이클(발급/갱신/배포/만료관리)을 체계적으로 관리할 수 있도록 돕는 솔루션입니다. 운영 리스크를 줄이고, 만료 사고를 예방하며, 관리 비용을 낮춥니다.",
        cta1: "CertBear 문의",
        cta2: "다른 서비스 보기",

        p1: "만료 알림/예방",
        p2: "운영 자동화",
        p3: "관리 대시보드",

        cardTitle: "핵심 기능",
        f1t: "만료 관리 & 알림",
        f1d: "인증서 만료일 추적, 사전 알림으로 서비스 중단 리스크를 줄입니다.",
        f2t: "발급/갱신 프로세스 표준화",
        f2d: "발급/갱신 업무를 표준 절차로 정리해 인수인계를 쉽게 만듭니다.",
        f3t: "운영 편의성 강화",
        f3d: "현황을 한눈에 보고, 필요한 조치를 빠르게 수행할 수 있도록 구성합니다.",

        noteTitle: "도입 포인트",
        note: "현재 운영 환경(웹서버/로드밸런서/인증서 발급 방식)에 맞춰 적용 범위를 설계합니다. 필요 시 배포 자동화(CI/CD, Docker)와 함께 묶어 운영 효율을 극대화할 수 있습니다.",

        section: {
          ariaLabel: "CertBear SSL 인증 솔루션",

          chip1: "SSL 인증 솔루션",
          chip2: "CertBear",

          title1: "SSL/TLS 인증서,",
          title2: "수집·모니터링·갱신까지 한 번에",

          p1: "짧아지는 SSL/TLS 인증서 유효기간에 대응하기 위해,\n자동화된 인증서 관리 기술을 자체적으로 개발했습니다.",
          p2: "복잡한 수작업 없이 인증서의 <b>수집, 모니터링, 갱신</b>까지 통합 관리하여 서비스 중단과 보안 리스크를 근본적으로 차단합니다.",

          points: [
            { title: "만료 사고 예방", desc: "만료일 추적 + 사전 알림" },
            { title: "운영 자동화", desc: "갱신 프로세스 표준화" },
            { title: "가시성", desc: "현황 대시보드로 한눈에" },
            { title: "리스크 절감", desc: "중단/보안 이슈 선제 대응" },
          ],

          cta1: "SSL 인증 솔루션 문의",
          cta2: "서비스 보기",

          stats: [
            { k: "수집", v: "자동 탐지" },
            { k: "모니터링", v: "상태/만료" },
            { k: "갱신", v: "프로세스화" },
          ],

          imageAlt: "CertBear 화면 예시",

          floating: {
            label: "CertBear",
            title: "SSL 관리 자동화",
          },

          features: [
            {
              title: "인증서 인벤토리",
              desc: "서비스/도메인별 인증서 현황을 자동 수집하고 표준화된 목록으로 관리합니다.",
            },
            {
              title: "만료/리스크 알림",
              desc: "만료 임박, 오류, 설정 누락 등 운영 리스크를 조기 탐지해 대응 시간을 확보합니다.",
            },
            {
              title: "운영 프로세스 정착",
              desc: "발급·갱신 업무를 조직에 맞게 정리해 인수인계를 쉽게 만들고 반복 작업을 줄입니다.",
            },
          ],

          featureNote: "* 필요 시 고객 환경(웹서버/로드밸런서/발급 방식)에 맞춰 확장 설계",
        },
      },
      process: {
        steps: [
          {
            n: "01",
            title: "요구사항 정리",
            desc: "목표·범위·우선순위를 정리해 기준을 하나로 맞춥니다.",
          },
          {
            n: "02",
            title: "기획 · 설계",
            desc: "화면 흐름과 데이터 구조를 잡고, 일정과 리스크를 예측합니다.",
          },
          {
            n: "03",
            title: "디자인 · UI",
            desc: "브랜드 톤을 반영해 컴포넌트를 설계하고, 사용성을 다듬습니다.",
          },
          {
            n: "04",
            title: "개발 · 테스트",
            desc: "기능을 구현하고 검증합니다. 안정성과 성능을 함께 챙깁니다.",
          },
          {
            n: "05",
            title: "배포 · 운영",
            desc: "CI/CD로 배포를 표준화하고, 운영 환경에 맞춰 안정화합니다.",
          },
          {
            n: "06",
            title: "모니터링 · 개선",
            desc: "지표와 로그로 이슈를 빠르게 발견하고, 지속적으로 개선합니다.",
          },
        ],
      },
      footer: {
        desc:
          "엔터프라이즈 IT 인프라 구축 및 운영 전문 기업, 비트윈소프트.\n" +
          "안정적인 기술과 신뢰를 바탕으로 고객의 IT 환경을 지원합니다.",

        linksTitle: "Links",
        links: {
          about: "회사소개",
          services: "서비스",
          certbear: "SSL 솔루션",
          contact: "문의",
        },

        contactTitle: "Contact",
        mailNote: "* 이메일 문의 환영",

        bottom: {
          top: "Top",
          contact: "Contact",
          rights: "All rights reserved.",
        },
      },
      trustbar: {
        flagshipLabel: "주력 솔루션",
        flagshipName: "CertBear",
        flagshipDesc: "SSL 인증서 수집·모니터링·갱신 자동화",
        partner: "TmaxSoft 공식 파트너",
        coverage: "대응 영역",
        items: ["JEUS", "WebtoB", "SSL/TLS", "API", "DevOps"],
        tagline: "운영 안정화 중심의 기술 파트너",
      },
      usecases: {
        eyebrow: "Use Cases",
        title: "이런 문제를 해결합니다",
        desc: "운영 현장에서 자주 마주치는 리스크를 구조적으로 줄입니다.",
        items: [
          {
            title: "인증서 만료 사고 예방",
            desc: "만료 추적·사전 알림·갱신 자동화로 서비스 중단을 막습니다.",
          },
          {
            title: "대량 API 트래픽 안정화",
            desc: "임계치·우선순위 기반 큐잉으로 피크 상황에서도 핵심 요청을 보호합니다.",
          },
          {
            title: "레거시 미들웨어 운영 고도화",
            desc: "JEUS·WebtoB 표준화·튜닝·장애 대응 체계로 예측 가능성을 높입니다.",
          },
          {
            title: "관리자·백오피스 리뉴얼",
            desc: "정보 구조와 UI/UX를 재정비해 운영 업무의 속도와 정확도를 개선합니다.",
          },
        ],
      },
      results: {
        eyebrow: "Results",
        title: "우리가 만든 변화",
        desc: "엔터프라이즈 특성상 수치 공개가 어려워, 대표적인 개선 방향을 정성적으로 정리했습니다.",
        items: [
          {
            title: "JEUS·WebtoB 운영 안정화",
            desc: "장애 대응 체계와 운영 표준을 잡아 미들웨어 환경의 예측 가능성을 높였습니다.",
          },
          {
            title: "SSL 인증서 관리 표준화",
            desc: "수집·모니터링·갱신을 프로세스화해 만료 사고 리스크를 구조적으로 줄였습니다.",
          },
          {
            title: "관리자·백오피스 리뉴얼",
            desc: "정보 구조와 UI/UX를 재정비해 운영 업무의 속도와 정확도를 개선했습니다.",
          },
          {
            title: "API 응답 안정성 개선",
            desc: "트래픽 제어와 모니터링을 도입해 피크 상황에서도 핵심 요청을 보호했습니다.",
          },
        ],
        note: "* 고객사 비공개 정책에 따라 구체 수치·고객명은 표기하지 않습니다.",
      },
      section: {
        servicesTitle: "핵심 솔루션",
        servicesDesc:
          "기업 서비스 운영에 필요한 핵심 기술을 제공합니다. 인증서 만료 사고 예방부터 API 트래픽 보호, JEUS·WebtoB 운영, 백오피스 구축까지 실무 중심으로 설계하고 운영합니다.",
        processTitle: "Process",
        processDesc: "불필요함을 줄이고, 일정과 품질을 향상하여 나아갑니다.",
        aboutTitle: "비트윈소프트",
        aboutDesc:
          "고객 환경에 맞춰 설계하고, 운영 리스크를 줄이는 구조로 구현합니다. 빠른 구축보다 안정적인 운영을 우선하며, 인수인계 가능한 표준 프로세스를 만듭니다.",
        contactTitle: "다음 프로젝트를 함께 설계해보세요",
        contactDesc:
          "간단한 요구사항만 있어도 괜찮습니다. 운영 환경과 목표에 맞는 방향을 빠르게 제안드립니다.",
        contact: {
          submit: "문의 접수하기",
          submitting: "전송 중...",
          mailto: "메일로 문의",
          fields: {
            company: "회사",
            companyPlaceholder: "비트윈소프트",
            name: "이름 *",
            inquiryType: "문의유형",
            phone: "연락처",
            phonePlaceholder: "010-1234-5678",
            email: "이메일 *",
            emailPlaceholder: "example@company.com",
            message: "내용 *",
            messagePlaceholder: "간단하게 적어주세요.",
          },
          validationRequired: "이름, 이메일, 문의 내용을 입력해주세요.",
          validationEmail: "이메일 형식을 확인해주세요.",
          submitted: "문의가 접수되었습니다. 빠르게 연락드리겠습니다.",
          submitFailed: "문의 접수 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
          note: "* 이름과 내용은 필수 입력이며, 접수 시 DB 저장 및 알림 메일이 발송됩니다.",
        },
      },
      about: {
        snapshotTitle: "Company Snapshot",
        snapshotNote: "* 고객사에 맞춰 기술 커스텀 제공.",
        info: {
          commTitle: "정확한 커뮤니케이션",
          commDesc: "문서화와 주간 공유로 리스크를 줄입니다.",
          maintainTitle: "유지보수 중심",
          maintainDesc: "기술 부채를 최소화하는 구조를 우선합니다.",
          perfTitle: "성능/SEO",
          perfDesc: "Core Web Vitals 기반으로 개선합니다.",
          securityTitle: "보안 기본기",
          securityDesc: "인증/권한/로그 등 기본을 놓치지 않습니다.",
        },
        snapshot: {
          engineering: "엔지니어링",
          development: "개발",
          collab: "협업",
          deploy: "배포",
          contact: "연락",
        },
      },
      partners: {
        eyebrow: "Partners",
        title: "함께 성장하는 파트너",
        desc: "검증된 파트너십과 협업으로 고객사의 운영 안정성과 기술 깊이를 동시에 끌어올립니다.",
        tmaxBadge: "Official",
        tmaxTitle: "TmaxSoft 공식 파트너",
        tmaxDesc:
          "엔터프라이즈 미들웨어 JEUS·WebtoB의 구축·마이그레이션·운영을 공식 파트너 자격으로 제공합니다.",
        tmaxScopeTitle: "협업 영역",
        tmaxScope: [
          "JEUS 구축·튜닝·마이그레이션",
          "WebtoB 설치·웹 트래픽 안정화",
          "장애 대응 및 운영 자동화",
          "공식 기술지원 채널 연계",
        ],
        inquireTitle: "협업·파트너십 제안",
        inquireDesc:
          "기술 파트너십, 공동 영업, 제품 통합 등 협업 문의를 환영합니다. 간단한 개요만 전달해주시면 빠르게 답변드립니다.",
        inquireCta: "문의하기",
        backCta: "홈으로",

        // === 셀프서비스 영역 (목업) ===
        login: {
          title: "파트너 로그인",
          subtitle: "딜 등록·관리를 위해 로그인하세요.",
          loginId: "아이디",
          loginIdPlaceholder: "아이디",
          password: "비밀번호",
          passwordPlaceholder: "비밀번호",
          submit: "로그인",
          submitting: "로그인 중…",
          signupPrompt: "아직 파트너가 아니신가요?",
          signupLink: "파트너 가입 신청하기",
          forgotPassword: "비밀번호 찾기",
          alreadyLoggedIn: "이미 로그인되어 있습니다.",
          toDashboard: "대시보드로 이동",
          toAdmin: "관리자 화면으로 이동",
          invalid: "아이디 또는 비밀번호를 확인하세요.",
        },
        passwordReset: {
          title: "비밀번호 재설정",
          requestDesc: "아이디를 입력하시면 가입 시 등록한 이메일로 재설정 링크를 보내드립니다.",
          requestSubmit: "재설정 메일 받기",
          requestSent: "재설정 메일을 보냈습니다. 메일함을 확인해 주세요.",
          confirmSendTitle: "재설정 메일 발송",
          registeredEmailLabel: "등록된 이메일",
          confirmSendDesc: "해당 메일로 비밀번호 재설정 메일을 발송하겠습니다.",
          confirmSendOk: "확인",
          confirmSendCancel: "취소",
          confirmDesc: "새 비밀번호를 입력하세요. (8자 이상)",
          confirmSubmit: "비밀번호 변경",
          confirmSuccess: "비밀번호가 변경되었습니다. 새 비밀번호로 로그인해 주세요.",
          submitting: "처리 중…",
          backToLogin: "로그인으로",
          loginId: "아이디",
          newPassword: "새 비밀번호",
          confirmPassword: "비밀번호 확인",
          passwordHint: "8자 이상의 영문·숫자·기호 조합 권장",
          errors: {
            loginIdRequired: "아이디를 입력하세요.",
            userNotFound: "등록되지 않은 아이디입니다.",
            passwordTooShort: "비밀번호는 8자 이상이어야 합니다.",
            passwordMismatch: "비밀번호가 일치하지 않습니다.",
            tokenInvalid: "재설정 토큰이 유효하지 않거나 만료되었습니다. 다시 요청해 주세요.",
            requestFailed: "요청에 실패했습니다. 잠시 후 다시 시도해 주세요.",
            confirmFailed: "비밀번호 변경에 실패했습니다.",
          },
        },
        signup: {
          title: "파트너 가입 신청",
          desc: "신청 후 관리자 검토를 거쳐 승인됩니다. 영업일 기준 2–4일 내 안내드립니다.",
          sectionCompany: "회사 정보",
          sectionContact: "영업대표 정보",
          sectionAccount: "계정",
          sectionTerms: "약관 동의",
          fields: {
            loginId: "아이디",
            loginIdPlaceholder: "영문 소문자로 시작 · 4~30자",
            loginIdHint: "영문 소문자/숫자/언더스코어, 영문으로 시작, 4~30자",
            companyName: "회사명",
            businessNumber: "사업자등록번호",
            businessNumberPlaceholder: "10자리 숫자",
            representativeName: "대표자명",
            companyEmail: "회사 이메일",
            industry: "업종",
            address: "주소",
            addressPlaceholder: "주소 검색으로 입력",
            addressSearch: "주소 검색",
            addressSearchTitle: "주소 검색",
            addressDetailPlaceholder: "상세 주소 (건물·층·호수 등)",
            salesRepHeadcount: "영업대표 인원수",
            techSupportHeadcount: "기술지원 인원수",
            headcountPlaceholder: "명 (선택)",
            contactName: "영업대표 이름",
            contactTitle: "영업대표 직책",
            contactEmail: "이메일",
            contactPhone: "휴대폰",
            contactPhonePlaceholder: "010-1234-5678",
            password: "비밀번호",
            passwordHint: "8자 이상, 영문+숫자+특수문자 포함",
            passwordConfirm: "비밀번호 확인",
            companyBrochure: "회사 소개서",
            companyBrochureHint: "PDF · DOC · PPT · HWP. 10MB 이내. 선택.",
            businessRegistration: "사업자등록증",
            bankbook: "통장 사본",
            docImageHint: "PDF · JPG · PNG · HEIC. 10MB 이내. 선택.",
            attach: "파일 선택",
            attached: "첨부됨",
            removeFile: "제거",
          },
          loginIdStatus: {
            checking: "확인 중…",
            available: "사용 가능한 아이디입니다.",
            taken: "이미 사용 중인 아이디입니다.",
            invalid: "형식이 올바르지 않습니다.",
          },
          terms: {
            service: "서비스 이용약관 동의 (필수)",
            privacy: "개인정보 수집·이용 동의 (필수)",
            marketing: "마케팅·홍보 수신 동의 (선택)",
            viewDetail: "전문 보기",
            viewSoon: "약관 전문은 준비중입니다.",
          },
          errors: {
            required: "필수 입력 항목입니다.",
            loginId: "영문 소문자로 시작하는 4~30자(영문/숫자/언더스코어) 아이디여야 합니다.",
            email: "이메일 형식이 올바르지 않습니다.",
            phone: "휴대폰 번호 형식이 올바르지 않습니다.",
            businessNumber: "사업자등록번호 10자리를 확인하세요.",
            businessNumberInvalid: "사업자등록번호가 유효하지 않습니다 (체크섬 실패).",
            password: "비밀번호 정책을 충족하지 않습니다.",
            passwordMismatch: "비밀번호가 일치하지 않습니다.",
            terms: "필수 약관에 동의해야 합니다.",
            companyRequired: "소속 회사를 검색해 선택하세요.",
            fileSize: "파일 크기가 10MB를 초과합니다.",
            fileType: "지원하지 않는 파일 형식입니다.",
            serverError:
              "신청 처리 중 오류가 발생했습니다. 잠시 후 다시 시도하거나 담당자에게 문의해주세요.",
          },
          existingPartnerNotice:
            "이미 가입된 회사입니다. 가입 신청 시 기존 회사에 담당자가 추가되는 형태로 검토됩니다.",
          kind: {
            title: "가입 유형",
            company: "신규 회사 가입",
            companyDesc: "처음 등록하는 회사입니다. 회사 정보와 첨부 서류를 함께 제출합니다.",
            member: "기존 회사 가입",
            memberDesc:
              "이미 등록된 회사의 영업대표입니다. 회사를 검색해 고르고, 내 계정과 영업대표 정보만 입력합니다.",
          },
          member: {
            sectionCompany: "소속 회사",
            searchLabel: "회사명 검색",
            searchPlaceholder: "회사명 2자 이상",
            searchHint:
              "등록된 파트너사만 검색됩니다. 찾는 회사가 없으면 '신규 회사 가입' 을 선택하세요.",
            searching: "검색 중…",
            searchFailed: "검색하지 못했습니다. 잠시 후 다시 시도해 주세요.",
            noResult: "검색 결과가 없습니다. 회사명을 확인하거나 '신규 회사 가입' 을 선택하세요.",
            companyLabel: "회사명",
            selectedHint: "회사 정보는 등록된 내용 그대로 사용됩니다.",
            change: "다시 검색",
            contactHint:
              "입력한 정보로 내 계정이 만들어지고, 이 계정의 첫 영업대표로 등록됩니다. 영업대표는 가입 후 [회사 정보] 에서 더 추가할 수 있습니다.",
          },
          submit: "가입 신청",
          submitting: "제출 중…",
          doneTitle: "신청이 접수되었습니다",
          doneDesc: "관리자 검토 후 안내드립니다.",
        },
        pending: {
          title: "승인 대기 중",
          desc: "가입 신청이 접수되었습니다. 영업일 기준 1–2일 내 검토 후 안내드립니다.",
          close: "닫기",
          viaTokenHint:
            "이 페이지는 신청 직후 임시로 표시됩니다. 닫으면 다시 보려면 승인 후 정식 로그인이 필요합니다.",
          memberHint: "승인되면 {{company}} 소속 계정으로 로그인할 수 있습니다.",
        },
        dashboard: {
          greet: "안녕하세요, {{company}} · {{name}}님",
          featured: { tag: "중요 공지", view: "보기" },
          // 심사 대기는 승인 전이라 다른 KPI 에 포함되지 않는다 — 대기 건이 있을 때만 카드로 노출
          kpi: {
            total: "전체 딜",
            inProgress: "진행중",
            adoption: "도입",
            lost: "실주",
            underReview: "심사 중",
          },
          addDeal: "+ 새 딜 등록",
          viewPerformance: "실적 보기",
          searchDeals: "딜 검색",
          editCompany: "회사 정보",
          filters: {
            all: "전체",
            // 심사 축 2개 — 영업단계와 한 줄에 섞어 두지만 값이 배타적이라(effectiveStatus)
            // 탭 동작은 어긋나지 않는다. **배지·KPI 와 문구가 다르다(의도)** — 탭은 10개가
            // 한 줄에 들어가야 하므로 형제 탭('제안'·'도입'·'실주')과 같은 명사 한 단어로 맞춘다.
            //   배지  partners.deals.review.pending  = '심사 중입니다' / rejected = '반려됨'
            //   KPI   partners.dashboard.kpi.underReview = '심사 중'
            //   탭    여기                                = '심사' / '반려'
            pending: "심사",
            brochure_sent: "제품 소개서 전달",
            intro: "제품 소개",
            prelim_quote: "예비 견적",
            poc: "PoC",
            proposal: "제안",
            adoption: "도입",
            lost: "실주",
            rejected: "반려",
            searchPlaceholder: "프로젝트명·고객사·등록자명 검색",
          },
          table: {
            projectName: "프로젝트명",
            customer: "고객사",
            registeredBy: "등록자",
            poAmount: "예상 PO 금액",
            poDate: "예상 PO 일자",
            status: "상태",
            createdAt: "등록일",
          },
          empty: "등록된 딜이 없습니다.",
        },
        profile: {
          title: "내 정보",
          back: "← 대시보드",
          sectionInfo: "계정 정보",
          sectionPassword: "비밀번호 변경",
          loginId: "로그인 ID",
          email: "이메일",
          emailHint: "이메일 변경은 관리자에게 요청해 주세요.",
          name: "이름",
          phone: "연락처",
          salesRepHint:
            "딜에 표시되는 영업대표 정보는 [회사 정보]의 영업대표 목록에서 따로 관리합니다.",
          save: "저장",
          saved: "저장되었습니다.",
          saveFailed: "저장하지 못했습니다. 잠시 후 다시 시도해 주세요.",
          loadFailed: "정보를 불러오지 못했습니다.",
          loadFailedHint:
            "내 정보를 불러오지 못해 지금은 수정할 수 없습니다. 잠시 후 다시 시도해 주세요.",
          retry: "다시 불러오기",
          noChanges: "바뀐 내용이 없습니다.",
          nameRequired: "이름을 입력해 주세요.",
          currentPassword: "현재 비밀번호",
          newPassword: "새 비밀번호",
          newPasswordConfirm: "새 비밀번호 확인",
          passwordRule: "8자 이상, 영문·숫자·특수문자를 각각 1자 이상 포함",
          passwordMismatch: "새 비밀번호가 일치하지 않습니다.",
          currentPasswordRequired: "현재 비밀번호를 입력해 주세요.",
          currentPasswordWrong: "현재 비밀번호가 일치하지 않습니다.",
          changePassword: "비밀번호 변경",
          passwordChanged: "비밀번호가 변경되었습니다.",
        },
        edit: {
          title: "회사 정보 수정",
          back: "이전",
          sectionBasics: "기본 정보",
          companyEmailHint:
            "회사 대표 이메일입니다. 공지 알림 메일은 각 계정의 이메일로 발송됩니다.",
          companyEmailInvalid: "올바른 회사 이메일을 입력해주세요.",
          sectionCompany: "회사 규모",
          sectionSalesReps: "영업대표",
          sectionTechSupports: "기술지원",
          addSalesRep: "+ 영업대표 인원 추가",
          addTechSupport: "+ 기술지원 인원 추가",
          removeRow: "삭제",
          salesRepScopeHint:
            "내 계정의 영업대표 목록입니다. 같은 회사의 다른 계정과 공유되지 않습니다.",
          saved: "저장되었습니다.",
          saveFailed: "저장 실패",
          loadFailed: "정보를 불러오지 못했습니다.",
          nameRequired: "이름은 필수입니다.",
          empty: "등록된 항목이 없습니다. + 버튼으로 추가하세요.",
          rowName: "이름",
          rowTitle: "직책",
          rowPhone: "연락처",
          rowEmail: "이메일",
          save: "저장",
        },
        common: {
          loading: "불러오는 중…",
        },
        dealSearch: {
          title: "딜 검색",
          subtitle: "전사에 등록된 딜을 프로젝트명·고객사명으로 검색합니다.",
          backToDashboard: "대시보드로",
          searchPlaceholder: "프로젝트명 또는 고객사명 입력",
          initialTitle: "검색어를 입력하세요",
          initialDesc: "프로젝트명 또는 고객사명 일부로 검색할 수 있습니다.",
          emptyTitle: "검색 결과가 없습니다",
          emptyDesc: "다른 검색어로 시도해 보세요.",
          mineTag: "(우리 회사)",
          privacyNote:
            "타사 파트너 정보 보호를 위해 파트너사명은 첫 글자만 표시됩니다. 본인 회사 딜만 풀네임으로 표시됩니다.",
          table: {
            projectName: "프로젝트명",
            customer: "고객사명",
            partner: "파트너사명",
            status: "영업단계",
          },
        },
        notices: {
          title: "공지사항",
          subtitle: "비트윈소프트가 전달하는 공지와 자료를 확인하세요.",
          backToDashboard: "대시보드로",
          searchPlaceholder: "제목으로 검색",
          emptyTitle: "등록된 공지가 없습니다",
          emptyDesc: "새로운 공지가 등록되면 여기에 표시됩니다.",
          pinnedTag: "고정",
          table: {
            title: "제목",
            author: "작성자",
            createdAt: "작성일",
            views: "조회",
            attachments: "첨부",
          },
          detail: {
            backToList: "목록으로",
            author: "작성자",
            createdAt: "작성일",
            views: "조회수",
            attachments: "첨부파일",
            noAttachments: "첨부파일이 없습니다.",
            notFound: "공지를 찾을 수 없습니다.",
            loadFailed: "공지를 불러오지 못했습니다.",
            downloadFailed: "다운로드에 실패했습니다.",
          },
        },
        performance: {
          title: "실적 현황 · {{company}}",
          period: { m3: "최근 3개월", m6: "최근 6개월", m12: "최근 12개월" },
          exportCsv: "CSV 내보내기",
          exportSoon: "CSV 내보내기는 준비중입니다.",
          adminBanner: "관리자 모드 — {{company}} 데이터 조회 중",
          adminBannerBack: "내 관리자 화면으로",
          kpi: {
            total: "누적 등록",
            inProgress: "진행중",
            adoption: "도입",
            lost: "실주",
            poAmount: "누적 예상 PO",
          },
          charts: {
            byQuarter: "분기별 등록 추이",
            byStatus: "영업단계별 분포",
            topCustomers: "상위 고객사 Top 5",
            recentActivity: "최근 활동",
            statusLabel: "상태",
          },
          emptyTitle: "표시할 실적이 없습니다",
          emptyDesc: "딜을 등록하면 실적 분석이 표시됩니다.",
          emptyCta: "딜 등록하러 가기",
        },
        deals: {
          form: {
            project: "프로젝트",
            projectName: "프로젝트 이름",
            sectionCustomer: "고객 정보",
            sectionPartner: "파트너 정보",
            sectionDeal: "거래 정보",
            customerCompany: "고객사명",
            customerCompanySearchPlaceholder: "회사명으로 검색 (2글자 이상)",
            customerCompanySearching: "검색 중…",
            customerCompanyNoResults: "검색 결과가 없습니다",
            customerCompanyChange: "변경",
            customerCompanyHint: "회사명을 검색해 목록에서 선택하세요 (직접 입력 불가)",
            customerCompanyMustSelect:
              "목록에서 회사를 선택해야 입력됩니다 — 타이핑만으론 등록되지 않습니다",
            customerCompanyChecking: "확인 중…",
            customerCompanyTaken: "이미 등록된 고객사라 선택할 수 없습니다",
            customerCompanyTakenAlertTitle: "이미 등록된 고객사입니다",
            customerCompanyTakenAlertBody: "총판사(비트윈소프트)에 문의해주세요.",
            customerCompanyTakenAlertOk: "확인",
            customerCompanyCorp: "법인",
            customerCompanyIndividual: "개인",
            customerBusinessNumber: "고객사 사업자등록번호",
            customerBusinessNumberHint:
              "앞자리는 조회 결과입니다. 뒷자리를 아시면 넣어주세요 — 선택 입력이며, 넣으면 고객사 선점 확인에 도움이 됩니다.",
            customerBusinessNumberSuspicious:
              "사업자등록번호를 다시 확인해주세요. 그대로 등록해도 됩니다.",
            customerBusinessNumberNone:
              "조회 결과에 사업자번호가 없습니다. 번호 없이도 등록됩니다.",
            customerBusinessNumberRef: "참고값",
            similarCustomer: "유사한 고객사가 {{count}}건 있습니다",
            similarCustomerMore: "외 {{count}}건",
            similarCustomerHint: "등록은 가능합니다. 같은 고객사가 아닌지 확인해주세요.",
            customerContactName: "담당자명",
            customerContactPosition: "담당자 직책",
            customerPhone: "휴대전화",
            customerEmail: "이메일",
            partnerCompany: "파트너사명",
            salesRepName: "영업대표 이름",
            salesRepHint: "회사 정보에 등록된 영업대표 중에서 선택",
            salesRepSelect: "영업대표 선택",
            salesRepEmptyHint: "등록된 영업대표가 없습니다. 회사 정보에서 추가하세요.",
            salesRepDeleted: "삭제된 영업대표 — 재선택 필요",
            salesRepPhone: "휴대전화",
            salesRepEmail: "이메일",
            poExpected: "예상 PO 일자",
            poQuarter: "분기",
            quarterAuto: "프로젝트 도입 날짜로부터 자동 계산",
            poDate: "프로젝트 도입",
            poDatePlaceholder: "날짜 선택",
            productDetail: "도입 환경",
            productDetailPlaceholder: "예) 하드웨어 종류, OS 환경, 미들웨어 등",
            poAmount: "예상 PO 금액 (원)",
            poAmountPlaceholder: "예: 10,000,000",
            vatExcluded: "VAT 별도",
            salesProgress: "영업 진행 사항",
            salesProgressPlaceholder:
              "예) webserver 종류, webserver(apache, tomcat, webtob, iis 등) 종류\n예) SSL 사용하는 장비 종류 : L7, 웹방화벽, 암복호화, 가시성 장비 등\n예) 현재 사용중인 SSL 인증서 명칭 및 수량\n예) 이중화 구성 여부, 망분리 구성여부\n예) 서버 종류 : Linux, Windows 등\n예) 기타 사항 : 고객 요구사항",
            channel: "협력사 경로",
            poc: "POC 필요 여부",
            pocRequired: "필요",
            pocNotRequired: "불필요",
            pocUndecided: "미정",
            brochure: "제품소개자료 전달",
            // submit·submitting 은 **딜 등록 전용이 아니다** — 5곳이 공유한다:
            //   submit      AdminDealNew / AdminDealEdit (관리자 딜은 심사를 타지 않는다)
            //   submitting  AdminDealForm / PartnerDealDetail(딜 수정 저장) / PartnerEdit(회사 정보 저장)
            // 그래서 이 두 키의 문구를 심사 쪽으로 바꾸면 위 5곳이 전부 어긋난다.
            // 파트너 신규 딜 등록 전용 문구는 아래 requestReview* 를 쓴다.
            submit: "등록",
            submitting: "등록 중…",
            // 파트너 신규 딜 등록 전용 — 등록이 곧 심사 요청이다(관리자 승인 후 활성 딜).
            // 관리자가 직접 등록하는 딜은 심사를 타지 않으므로 이 문구를 쓰지 않는다.
            requestReview: "심사 요청",
            requestingReview: "심사 요청 중…",
            reviewRequested: "심사 요청이 접수되었습니다. 관리자 승인 후 딜 목록에 올라갑니다.",
            createFailed: "딜 등록 실패",
          },
          blocked: {
            title: "딜 등록 제한",
            body: "현재 딜 등록이 되지 않습니다. 관리자에게 문의해 주세요.",
            ok: "확인",
          },
          status: {
            brochure_sent: "제품 소개서 전달",
            intro: "제품 소개",
            prelim_quote: "예비 견적",
            poc: "PoC",
            proposal: "제안",
            adoption: "도입",
            lost: "실주",
          },
          // 심사 상태 — 영업단계와 별개 축. 딜 변경 이력(DealChangeHistory)도 이 키를 쓴다.
          review: {
            label: "심사 상태",
            pending: "심사 중입니다",
            approved: "승인",
            rejected: "반려됨",
          },
          detail: {
            statusLabel: "영업단계",
            reviewPendingBanner: "심사 중입니다 — 관리자 승인 후 딜 목록에 반영됩니다",
            reviewPendingHint:
              "승인 전까지 이 딜은 딜 목록·통계·실적에 포함되지 않습니다. 내용은 계속 수정하실 수 있습니다.",
            reviewRejectedBanner: "반려되어 삭제된 딜입니다 — 열람 전용",
            reviewRejectedReason: "반려 사유",
            reviewRejectedHint:
              "이 딜은 수정하거나 되살릴 수 없습니다. 사유를 반영해 새 딜로 다시 등록해 주세요.",
            registerAgain: "새 딜 등록",
            readOnlyNotOwner:
              "{{name}} 님이 담당하는 딜입니다. 수정·삭제는 담당 계정에서만 할 수 있어 열람만 가능합니다.",
            registeredBy: "등록자",
            // 관리자 담당자 변경으로 등록 계정과 담당 계정이 달라진 딜
            ownedBy: "담당",
            registeredAt: "등록일",
            // count = 경과일. ko 는 복수형이 없어 기본 키 하나로 처리
            lastUpdated: "최종 Update {{date}} (경과일 : {{count}}일)",
            requestEdit: "수정",
            requestEditSoon: "수정 기능은 준비중입니다.",
            cancel: "취소",
            backToList: "목록으로",
            adminMemo: "관리자 내부 메모",
            adminStatus: "영업단계 변경",
            notFound: "딜을 찾을 수 없거나 권한이 없습니다.",
            vatNote: "(VAT 별도)",
            save: "저장",
            statusChanged: "영업단계가 변경되었습니다.",
            statusChangeFailed: "영업단계 변경 실패",
            statusChangeConfirmTitle: "영업단계 변경",
            statusChangeConfirmContent:
              "영업단계를 '{{from}}' 에서 '{{to}}' (으)로 변경하시겠습니까?",
            statusChangeConfirmOk: "변경",
            statusChangeConfirmCancel: "취소",
            edit: "수정",
            editSaved: "수정 내용이 저장되었습니다.",
            editSaveFailed: "저장 실패",
            delete: "딜 삭제",
            dangerZone: "위험 영역",
            deleteSectionTitle: "이 딜을 삭제합니다",
            deleteSectionHint:
              "삭제된 딜은 목록·검색·실적에서 사라지며, 삭제 후에는 되돌릴 수 없습니다. 신중하게 결정해 주세요.",
            deleteConfirmTitle: "딜을 삭제하시겠습니까?",
            deleteConfirmContent:
              "삭제된 딜은 목록·검색·실적에서 더 이상 보이지 않습니다. 신중하게 결정해 주세요.",
            deleteConfirmOk: "삭제",
            deleteConfirmCancel: "취소",
            deleteReasonPlaceholder:
              "삭제 사유 (선택, 500자 이내) — 관리자 [삭제된 딜] 목록에 표시됩니다",
            deletedBanner: "삭제된 딜 — 열람 전용",
            deletedMeta: "삭제일: {{at}} · 삭제자: {{by}}",
            deletedReasonLabel: "삭제 사유",
            deletedNoReason: "(입력된 사유 없음)",
            deleteDone: "딜을 삭제했습니다.",
            deleteFailed: "딜 삭제에 실패했습니다.",
            memoSaved: "메모가 저장되었습니다.",
            memoSaveFailed: "메모 저장 실패",
            memoSaving: "저장 중...",
            adminMemoHint: "내부 전용 · 파트너에게는 보이지 않습니다",
            adminMemoPlaceholder: "고객 응대 메모, 내부 공유 사항 등을 기록하세요",
            partnerMemo: "파트너 메모",
            partnerMemoLabel: "메모 (관리자에게 전달)",
            partnerMemoPlaceholder: "관리자에게 전달할 내용을 입력하세요 (선택)",
            messages: {
              titleAdmin: "파트너에게 보내는 메시지",
              titlePartner: "관리자 메시지",
              hintAdmin: "파트너에게 공개됩니다 · 작성 시 영업대표 이메일로 알림 메일이 발송됩니다",
              hintPartner: "비트윈소프트 담당자가 이 딜에 남긴 메시지입니다",
              placeholder: "파트너에게 전달할 의견이나 요청 사항을 입력하세요",
              send: "메시지 보내기",
              sending: "전송 중...",
              empty: "등록된 메시지가 없습니다.",
              recipient: "알림 수신: {{email}}",
              noRecipientHint: "영업대표 이메일이 없어 알림 메일은 발송되지 않습니다",
              unknownAuthor: "(알 수 없음)",
              adminActor: "관리자",
              mailStatus: {
                sent: "발송됨",
                failed: "발송 실패",
                no_recipient: "수신자 없음",
                pending: "발송 미확인",
              },
              sentOk: "메시지를 저장하고 알림 메일을 발송했습니다.",
              savedMailFailed: "메시지는 저장됐지만 알림 메일 발송에 실패했습니다.",
              savedNoRecipient:
                "메시지를 저장했습니다. 영업대표 이메일이 없어 알림 메일은 발송되지 않았습니다.",
              savedMailUnknown: "메시지를 저장했습니다. 알림 메일 발송 결과를 확인하지 못했습니다.",
              sendFailed: "메시지 전송 실패",
              required: "메시지 내용을 입력하세요.",
            },
            quotation: "견적서",
            quotationUpload: "업로드",
            quotationReplace: "교체",
            quotationUploading: "업로드 중…",
            quotationUploaded: "견적서 업로드 완료",
            quotationUploadFailed: "견적서 업로드 실패",
            quotationDownloadFailed: "견적서 다운로드 실패",
            adoptionFiles: "도입 증빙 파일",
            adoptionFilesHint: "계약서·견적서 등 도입 증빙 자료입니다.",
            adoptionFilesManageHint: "도입 처리한 담당자만 교체(추가·삭제)할 수 있습니다.",
            adoptionRequiredHint:
              "도입 단계로 변경하려면 계약서·견적서 등 증빙 파일을 1개 이상 업로드해야 합니다.",
            adoptionExistingHint:
              "이미 업로드된 증빙 파일 {{count}}개가 있어 추가 업로드 없이 변경할 수 있습니다.",
            adoptionFilesLabel: "증빙 파일 (필수)",
            adoptionPick: "파일 선택",
            adoptionPickHint:
              "PDF·Office·HWP·이미지·ZIP, 파일당 {{maxSizeMb}}MB, 최대 {{maxFiles}}개",
            adoptionRemovePending: "제거",
            adoptionAdd: "파일 추가",
            adoptionDelete: "삭제",
            adoptionDeleteConfirm:
              "'{{name}}' 파일을 삭제할까요? 삭제한 파일은 되돌릴 수 없습니다.",
            adoptionMinLocked: "도입 단계에서는 증빙 파일이 최소 1개 필요합니다.",
            adoptionUploading: "업로드 중…",
            adoptionAdded: "증빙 파일이 추가되었습니다.",
            adoptionDeleted: "증빙 파일이 삭제되었습니다.",
            adoptionFailed: "증빙 파일 처리 실패",
            adoptionDownloadFailed: "파일 다운로드 실패",
            adoptionNone: "등록된 증빙 파일이 없습니다.",
            adoptionTooMany: "증빙 파일은 최대 {{max}}개까지 업로드할 수 있습니다.",
            adoptionTooLarge: "'{{name}}' 파일이 {{maxSizeMb}}MB 를 초과합니다.",
            adoptionBadType: "'{{name}}' 은(는) 지원하지 않는 파일 형식입니다.",
          },
        },
      },
      common: {
        unitKrw: "원",
        unitCount: "건",
        loading: "불러오는 중…",
      },
      admin: {
        title: "관리자 대시보드",
        featured: { tag: "중요 공지", view: "보기" },
        tabs: {
          deals: "딜 관리",
          reviews: "딜 심사",
          signups: "파트너 가입 신청",
          partners: "파트너",
          performance: "파트너 실적",
          stale: "관리 대상 딜",
          deleted: "삭제된 딜",
          notices: "공지사항 관리",
          stats: "통계",
        },
        // [딜 심사] 탭 — 파트너가 올린 딜의 승인·반려
        dealReviews: {
          subPending: "심사 대기",
          subDone: "처리 완료",
          submittedAt: "제출일",
          company: "파트너사",
          projectName: "프로젝트명",
          customer: "고객사",
          poAmount: "예상 PO",
          salesRep: "영업대표",
          daysWaiting: "대기",
          days: "{{count}}일",
          action: "심사",
          result: "결과",
          reviewedAt: "심사 시각",
          reviewedBy: "심사자",
          reason: "반려 사유",
          reasonView: "사유 보기",
          reasonTitle: "반려 사유",
          approve: "승인",
          reject: "반려",
          emptyPending: "심사 대기 중인 딜이 없습니다.",
          emptyDone: "심사를 처리한 딜이 없습니다.",
          searchPlaceholder: "파트너사·고객사·영업대표 검색",
          searchEmpty: "검색 결과가 없습니다.",
          rejectedDeletedNote: "삭제된 딜",
          rejectedMovedHint:
            "승인·반려한 딜이 함께 표시됩니다. 반려한 딜은 삭제 처리되므로 [삭제된 딜] 탭에서도 확인할 수 있습니다.",
          approved: "{{customer}} 딜을 승인했습니다.",
          rejected: "{{customer}} 딜을 반려했습니다.",
          alreadyReviewed: "다른 관리자가 이미 처리한 딜입니다. 목록을 새로 불러왔습니다.",
          actionFailed: "처리에 실패했습니다.",
          rejectReasonRequired: "반려 사유를 입력해 주세요.",
          rejectReasonLabel: "반려 사유 (파트너에게 그대로 전달됩니다)",
          rejectReasonPlaceholder:
            "무엇을 보완해야 하는지 구체적으로 적어 주세요. 예: 견적서가 누락되었습니다.",
          confirmApprove: {
            title: "이 딜을 승인할까요?",
            body: "{{company}} 의 고객사 [{{customer}}] 딜을 승인합니다.",
            hint: "승인하면 즉시 딜 목록·통계·실적에 반영됩니다. 승인 취소는 제공되지 않습니다.",
          },
          confirmReject: {
            title: "딜 반려",
            body: "{{company}} 의 고객사 [{{customer}}] 딜을 반려합니다.",
            preemptionWarning:
              "반려하면 이 고객사에 대한 선점이 풀려, 다른 파트너사가 같은 고객사로 딜을 등록할 수 있습니다.",
          },
        },
        deletedDeals: {
          deletedAt: "삭제일",
          company: "파트너/등록",
          projectName: "프로젝트명",
          customer: "고객사",
          salesRep: "영업대표",
          status: "영업단계",
          deletedBy: "삭제자",
          reason: "사유",
          reasonView: "보기",
          noReasonShort: "(사유 없음)",
          reasonTitle: "삭제 사유",
          noReason: "입력된 삭제 사유가 없습니다.",
          rejectReason: "심사 반려 사유",
          reasonClose: "닫기",
          empty: "삭제된 딜이 없습니다.",
          searchPlaceholder: "파트너사·고객사·영업대표 검색",
          searchEmpty: "검색 결과가 없습니다.",
        },
        partners: {
          title: "파트너사 관리",
          desc: "딜 등록을 제한하면 해당 파트너사는 새 딜을 등록할 수 없습니다. 기존 딜 조회·수정·삭제는 그대로입니다.",
          company: "파트너사",
          businessNumber: "사업자번호",
          status: "상태",
          statusActive: "정상",
          statusInactive: "비활성",
          statusSuspended: "정지",
          statusDeleted: "삭제됨",
          deleteColumn: "삭제",
          delete: "삭제",
          deleting: "삭제 중…",
          deletedMeta: "{{date}} · {{admin}}",
          deletedDeals: "삭제됨 {{count}}건",
          confirmDelete: {
            title: "이 파트너사를 삭제할까요?",
            body: "{{company}} 소속 계정이 모두 로그인할 수 없게 됩니다.",
            accounts: "소속 로그인 계정 {{count}}개가 함께 삭제됩니다.",
            deals:
              "이 회사가 등록한 딜 {{count}}건도 함께 삭제되어 [삭제된 딜] 탭에서만 열람할 수 있습니다.",
            hint: "첨부 파일·이력은 그대로 남습니다. 되돌릴 수 없습니다.",
            rejoin: "삭제한 회사는 같은 사업자등록번호로 다시 가입 신청할 수 있습니다.",
            ok: "삭제",
            cancel: "취소",
          },
          deals: "딜",
          dealPermission: "딜 등록",
          permitAllowed: "허용",
          permitBlocked: "제한",
          lastChanged: "{{date}} · {{admin}} 변경",
          searchPlaceholder: "회사명·사업자번호·아이디·이메일 검색",
          searchEmpty: "검색 결과가 없습니다.",
          noAccounts: "등록된 계정이 없습니다.",
          confirmBlock: {
            title: "딜 등록을 제한할까요?",
            body: "{{company}} 는 새 딜을 등록할 수 없게 됩니다. 기존 딜 조회·수정·삭제는 그대로입니다.",
            ok: "제한",
            cancel: "취소",
          },
          toasts: {
            allowed: "{{company}} 의 딜 등록을 허용했습니다.",
            blocked: "{{company}} 의 딜 등록을 제한했습니다.",
            saveFailed: "변경에 실패했습니다.",
            deleted: "{{company}} 을(를) 삭제했습니다. 해당 계정은 로그인할 수 없습니다.",
            deletedWithDeals:
              "{{company}} 을(를) 삭제했습니다. 딜 {{count}}건은 [삭제된 딜] 탭에서 확인할 수 있습니다.",
            deleteFailed: "삭제에 실패했습니다.",
          },
        },
        accounts: {
          loginId: "아이디",
          name: "이름",
          email: "이메일",
          phone: "연락처",
          lastLogin: "최근 로그인",
          changeEmail: "이메일 변경",
          modalTitle: "이메일 변경",
          newEmail: "새 이메일",
          newEmailHint: "비밀번호 재설정 메일이 이 주소로 발송됩니다.",
          save: "변경",
          cancel: "취소",
          toasts: {
            saved: "계정 이메일이 변경되었습니다.",
            saveFailed: "이메일 변경에 실패했습니다.",
            invalidEmail: "올바른 이메일 형식이 아닙니다.",
          },
        },
        stats: {
          sectionSignups: "가입 신청 현황",
          sectionByStage: "영업단계별 딜 분포",
          kpi: {
            partners: "총 파트너",
            activePartners: "활성 파트너",
            deals: "총 딜",
            inProgress: "진행중 딜",
            poTotal: "누적 예상 PO",
          },
          signup: { pending: "대기", approved: "승인", rejected: "반려" },
          table: { stage: "영업단계", distribution: "분포", count: "건수" },
          datasetSection: "고객사 검색 데이터셋",
          datasetMonth: "활성 데이터(월)",
          datasetMonthValue: "{{year}}년 {{month}}월",
          datasetRowCount: "사업장 수",
          datasetAutoAt: "자동 갱신",
          datasetLastChecked: "마지막 확인",
          datasetNever: "미확인",
          datasetRefresh: "지금 갱신",
          datasetRefreshing: "갱신 중…",
          datasetRefreshDone: "{{month}} 데이터로 갱신했습니다.",
          datasetRefreshKept: "이미 최신 데이터입니다.",
          datasetRefreshSparse: "새 월 데이터가 아직 준비 중이라 현재 데이터를 유지합니다.",
          datasetRefreshUnavailable:
            "데이터 제공처 확인에 실패해 갱신하지 못했습니다. 잠시 후 다시 시도하세요.",
          datasetRefreshFailed: "갱신에 실패했습니다.",
          datasetPinned:
            "환경변수(NPS_DATASET_UUID)로 특정 월에 고정되어 있어 자동 갱신이 적용되지 않습니다.",
        },
        notices: {
          addNotice: "공지 등록",
          newTitle: "공지 등록",
          editTitle: "공지 수정",
          statusDraft: "임시저장",
          statusPublished: "발행",
          pinnedTag: "고정",
          table: {
            title: "제목",
            status: "상태",
            author: "작성자",
            createdAt: "작성일",
            views: "조회",
            attachments: "첨부",
          },
          form: {
            title: "제목",
            titlePlaceholder: "공지 제목을 입력하세요",
            content: "내용",
            contentPlaceholder: "공지 내용을 입력하세요",
            status: "상태",
            statusDraft: "임시저장 (파트너 비공개)",
            statusPublished: "발행 (파트너 공개)",
            isPinned: "목록 상단 고정",
            isFeatured: "대시보드 메인 공지 (한 건만 유지)",
            notifyPartners: "파트너사에 공지 등록 알림 메일 발송",
            notifyPartnersHint:
              "발행 상태로 등록하면 활성 파트너사의 각 계정 이메일로 알림이 발송됩니다.",
            attachments: "첨부파일",
            attachmentsHint: "PDF·문서·이미지·압축, 파일당 10MB, 최대 10개",
            addFiles: "파일 추가",
            newFiles: "추가할 파일",
            existingAttachments: "등록된 첨부",
            remove: "제거",
            submit: "저장",
            cancel: "취소",
          },
          toasts: {
            created: "공지를 등록했습니다.",
            createFailed: "공지 등록에 실패했습니다.",
            updated: "공지를 수정했습니다.",
            updateFailed: "공지 수정에 실패했습니다.",
            deleted: "공지를 삭제했습니다.",
            deleteFailed: "공지 삭제에 실패했습니다.",
            loadFailed: "공지를 불러오지 못했습니다.",
            uploadFailed: "첨부 업로드에 실패했습니다.",
            attachmentRemoved: "첨부를 삭제했습니다.",
            attachmentRemoveFailed: "첨부 삭제에 실패했습니다.",
            required: "제목과 내용을 입력하세요.",
          },
          deleteConfirmTitle: "이 공지를 삭제하시겠습니까?",
          deleteConfirmContent: "삭제된 공지와 첨부파일은 복구할 수 없습니다.",
          deleteConfirmOk: "삭제",
          deleteConfirmCancel: "취소",
          dangerZone: "위험 영역",
          deleteSectionTitle: "이 공지를 삭제합니다",
          deleteSectionHint: "삭제된 공지와 첨부파일은 복구할 수 없습니다.",
          delete: "공지 삭제",
        },
        filters: {
          searchPlaceholder: "키워드 검색",
          partner: "파트너사",
          status: "상태",
          period: "기간",
          allPartners: "전체 파트너",
          allStatus: "전체 상태",
        },
        table: {
          partner: "파트너사",
          projectName: "프로젝트명",
          customer: "고객사",
          poAmount: "예상 금액",
          poDate: "예상 일자",
          status: "상태",
          createdAt: "등록일",
          adminBadge: "관리자",
        },
        deals: {
          addDeal: "+ 딜 등록",
          editDeal: "딜 수정",
          newTitle: "관리자 딜 등록",
          editTitle: "관리자 딜 수정",
          sectionRegistrant: "등록자",
          registrant: "등록 관리자",
          adminCompany: "관리자 회사",
          representativeName: "대표자명",
          sectionSalesRep: "영업대표 정보",
          salesRepName: "영업대표 이름",
          salesRepPhone: "영업대표 전화",
          salesRepEmail: "영업대표 이메일",
          submitted: "딜이 등록되었습니다.",
          updated: "딜이 수정되었습니다.",
          createFailed: "딜 등록에 실패했습니다.",
          updateFailed: "딜 수정에 실패했습니다.",
          loadFailed: "딜 정보를 불러오지 못했습니다.",
          backToList: "목록으로",
          editForbiddenPartnerDeal: "파트너 등록 딜은 이 화면에서 수정할 수 없습니다.",
          editForbiddenNotOwner: "본인이 등록한 딜만 수정할 수 있습니다.",
          changeHistory: {
            title: "변경 이력",
            empty: "기록된 변경 내역이 없습니다.",
            unknownUser: "(알 수 없음)",
            partnerActor: "파트너",
            adminActor: "관리자",
            boolTrue: "예",
            boolFalse: "아니오",
            // 담당자 변경 이력 — 컬럼이 아닌 표시용 이름 키
            partnerCompany: "파트너사",
            ownerAccount: "담당 계정",
          },
          ownerChange: {
            button: "담당자 변경",
            title: "딜 담당자 변경",
            currentPartner: "현재 파트너사",
            currentSalesRep: "현재 영업대표",
            currentMark: "현재",
            partner: "파트너사",
            partnerSelect: "파트너사를 선택하세요",
            salesRep: "영업대표",
            salesRepSelect: "영업대표를 선택하세요",
            noSalesRep: "이 파트너사에 등록된 영업대표가 없습니다.",
            ownerAccount: "담당 계정: {{name}} ({{loginId}})",
            ownerInactive: "계정 비활성",
            account: "담당 계정",
            accountSelect: "담당 계정을 선택하세요",
            accountHint:
              "소유 계정이 지정되지 않은 영업대표입니다. 이 딜을 수정할 계정을 선택하세요.",
            noAccount: "이 파트너사에 활성 계정이 없습니다.",
            warning:
              "메시지·첨부 파일을 포함한 딜 전체가 새 파트너사와 담당자에게 넘어가며, 기존 파트너사는 이 딜을 볼 수 없습니다. 최초 등록자 기록은 유지됩니다.",
            loading: "불러오는 중…",
            cancel: "취소",
            ok: "변경",
            submitting: "변경 중…",
            done: "담당자를 변경했습니다.",
            failed: "담당자 변경에 실패했습니다.",
            loadFailed: "목록을 불러오지 못했습니다.",
          },
        },
        signup: {
          searchPlaceholder: "회사명·담당자 검색",
          searchEmpty: "검색 결과가 없습니다.",
          loginId: "아이디",
          company: "회사명",
          contact: "담당자",
          email: "이메일",
          submittedAt: "신청일",
          status: "상태",
          statusPending: "대기",
          statusApproved: "승인",
          statusRejected: "반려",
          approve: "승인",
          reject: "반려",
          rejectReasonPlaceholder: "반려 사유를 입력하세요",
          confirmApprove: "이 신청을 승인하시겠습니까?",
          confirmReject: "이 신청을 반려하시겠습니까?",
          detailTitle: "신청 상세",
          memberSignup: "기존 회사 가입",
          duplicateCompany: "등록된 사업자번호",
          newCompany: "신규 회사 가입",
          memberSignupHint:
            "이미 등록된 {{company}} 에 계정을 추가하는 신청입니다. 승인하면 신청자 계정이 만들어지고, 입력한 영업대표 정보가 그 계정의 첫 영업대표로 등록됩니다. 회사 정보는 등록된 값 그대로입니다.",
          duplicateCompanyHint:
            "같은 사업자번호의 {{company}} 가(이) 이미 등록돼 있어 신규 회사로 승인할 수 없습니다. 반려하고 신청자에게 '기존 회사 가입' 으로 다시 신청하도록 안내해 주세요.",
          approveSoon: "승인 처리는 목업입니다 — 콘솔에만 기록됩니다.",
          type: "유형",
          businessNumber: "사업자번호",
          representativeName: "대표자명",
          companyEmail: "회사 이메일",
          industry: "업종",
          address: "주소",
          salesRepHeadcount: "영업대표 인원",
          techSupportHeadcount: "기술지원 인원",
          phone: "휴대폰",
          termsService: "이용약관",
          privacyConsent: "개인정보 수집·이용",
          marketing: "마케팅 동의",
          rejectReasonLabel: "사유",
          brochureFallback: "회사 소개서",
          downloadBrochure: "회사 소개서 다운로드",
          downloadBusinessRegistration: "사업자등록증 다운로드",
          downloadBankbook: "통장 사본 다운로드",
          toasts: {
            detailLoadFailed: "신청 상세를 불러오지 못했습니다.",
            approved: "승인 완료",
            approveFailed: "승인 실패",
            rejected: "반려 완료",
            rejectFailed: "반려 실패",
            downloadFailed: "다운로드 실패",
          },
        },
        performance: {
          kpi: { partners: "전체 파트너", active: "거래 파트너", poTotal: "전체 누적 PO" },
          table: {
            partner: "파트너사",
            totalDeals: "누적 딜",
            inProgress: "진행중",
            adoption: "도입",
            lost: "실주",
            poTotal: "누적 PO 금액",
            lastActivity: "최근 활동",
          },
        },
        staleDeals: {
          periodLabel: "정체 기간",
          bulk: {
            button: "안내 메일 일괄 발송",
            loading: "대상 확인 중…",
            confirmTitle: "갱신 요청 안내 일괄 발송",
            confirmSummary:
              "발송할 딜을 체크하세요. 같은 수신자의 딜은 한 통에 정리됩니다. (후보 {{deals}}건 · 수신자 {{recipients}}명)",
            selectAll: "전체 선택",
            selectedSummary: "선택 {{deals}}건 · 수신자 {{recipients}}명",
            noneSelected: "발송할 딜을 1건 이상 선택하세요.",
            skippedNote:
              "제외: 이미 발송됨 {{already}}건 · 받을 수 있는 계정 없음(이메일 없음·정지·삭제) {{noRecipient}}건",
            notInListNote: "선택한 딜 중 {{n}}건은 목록이 갱신되어 제외됩니다.",
            nothingToSend: "발송할 대상이 없습니다. (이미 발송된 딜 {{skipped}}건 제외)",
            tooManyResults: "검색 결과가 {{max}}건을 넘습니다. 검색어를 좁혀 주세요.",
            confirmOk: "선택 발송",
            confirmOkCount: "선택 발송 ({{n}}건)",
            toasts: {
              sent: "안내 메일 {{mails}}통({{deals}}건 딜)을 발송했습니다.",
              partial: "{{mails}}통 발송, {{failed}}통 실패 — 실패분은 재시도 가능합니다.",
              failed: "일괄 발송에 실패했습니다.",
            },
          },
          notice: {
            colTitle: "안내 메일",
            send: "메일 발송",
            sending: "발송 중…",
            sent: "발송됨",
            confirmTitle: "딜 갱신 요청 안내 발송",
            confirmRecipient: "수신자",
            previewLabel: "발송될 메일 내용",
            confirmDesc: "발송 후에는 딜이 갱신되기 전까지 재발송할 수 없습니다.",
            confirmOk: "발송",
            confirmCancel: "취소",
            toasts: {
              sent: "안내 메일을 발송했습니다.",
              alreadySent: "이미 안내 메일이 발송된 딜입니다.",
              noRecipient:
                "받을 수 있는 등록 계정이 없어(이메일 없음 또는 계정 정지·삭제) 발송할 수 없습니다.",
              failed: "안내 메일 발송에 실패했습니다.",
            },
          },
          excel: "엑셀 다운로드",
          excelDownloading: "다운로드 중…",
          excelFailed: "엑셀 다운로드에 실패했습니다.",
          period: {
            "3d": "3일",
            "5d": "5일",
            "1w": "1주",
            "2w": "2주",
            "3w": "3주",
            "1m": "1달",
            "2m": "2달",
            "3m": "3달",
          },
          count: "{{n}}건",
          daysAgo: "{{days}}일 정체",
          empty: "해당 기간 이상 정체된 진행중 딜이 없습니다.",
          searchPlaceholder: "파트너사·고객사·영업대표 검색",
          searchEmpty: "검색 결과가 없습니다.",
          table: {
            company: "파트너/등록",
            projectName: "프로젝트명",
            customer: "고객사",
            salesRep: "영업대표",
            status: "영업단계",
            lastUpdated: "마지막 변동",
            daysSince: "정체 일수",
          },
          setting: {
            title: "자동 알림 설정",
            desc: "설정한 기간 이상 변동(진행) 없이 정체된 진행중 딜을 매일 지정한 시각에 활성 관리자에게 메일로 발송합니다. (도입/실주 딜은 제외)",
            enabled: "자동 발송 사용",
            autoSend: "자동 발송",
            thresholdDays: "정체 기준",
            daysOption: "{{days}}일",
            sendAt: "발송 시각 (KST)",
            save: "설정 저장",
            sendNow: "지금 발송",
            saved: "설정을 저장했습니다.",
            saveFailed: "설정 저장에 실패했습니다.",
            sendSent: "관리 대상 딜 {{n}}건을 관리자 {{recipients}}명에게 발송했습니다.",
            sendSkipped: "발송할 관리 대상 딜이 없습니다.",
            sendFailed: "메일 발송에 실패했습니다.",
            lastRun: "마지막 자동 발송",
            lastRunCount: "{{n}}건",
            never: "발송 이력 없음",
            on: "사용",
            off: "미사용",
            autoAlert: "자동 알림",
            statusOn: "켜짐",
            statusOff: "꺼짐",
            details: "상세 설정",
            turnedOn: "자동 알림을 켰습니다.",
            turnedOff: "자동 알림을 껐습니다.",
            activeSummary: "정체 {{days}}일 이상 · 매일 {{time}} 발송",
            saveHint:
              "정체 기준·발송 시각을 바꾼 뒤 저장하면 자동 알림이 이 값으로 동작합니다. 켜짐/꺼짐은 위 토글로 조절합니다.",
          },
        },
        empty: "데이터가 없습니다.",
        salesReps: {
          title: "영업대표 관리",
          hint: "딜 등록 시 셀렉트로 선택하면 이름·전화·이메일이 자동 입력됩니다.",
          backToAdmin: "관리자 홈",
          addTitle: "영업대표 추가",
          editTitle: "영업대표 수정",
          name: "이름",
          position: "직책",
          phone: "전화번호",
          email: "이메일",
          actions: "작업",
          add: "추가",
          edit: "수정",
          save: "저장",
          cancel: "취소",
          delete: "삭제",
          empty: "등록된 영업대표가 없습니다. 위에서 추가하세요.",
          added: "영업대표를 추가했습니다.",
          updated: "영업대표를 수정했습니다.",
          deleted: "영업대표를 삭제했습니다.",
          saveFailed: "저장에 실패했습니다.",
          deleteFailed: "삭제에 실패했습니다.",
          deleteConfirmTitle: "영업대표를 삭제하시겠습니까?",
          deleteConfirmContent:
            "'{{name}}' 을(를) 삭제합니다. 기존 딜에 적힌 영업대표 정보는 그대로 보존됩니다.",
          deleteConfirmOk: "삭제",
          deleteConfirmCancel: "취소",
          selectPlaceholder: "영업대표 선택",
          selectHint: "선택하면 전화·이메일이 자동 채워집니다",
          emptyHint: "등록된 영업대표가 없습니다.",
        },
      },
      auth: {
        guard: {
          loginRequired: "로그인이 필요합니다.",
          partnerOnly: "승인된 파트너만 접근할 수 있습니다.",
          adminOnly: "관리자만 접근할 수 있습니다.",
          pendingOnly: "가입 신청 중인 사용자만 접근할 수 있습니다.",
          sessionExpired: "세션이 만료되었습니다. 다시 로그인해주세요.",
        },
      },
      dev: {
        roleSwitcher: {
          label: "역할",
          options: {
            guest: "비로그인",
            pending: "가입신청중",
            partner: "승인된 파트너",
            admin: "관리자",
          },
          hint: "개발용 (운영 빌드에선 숨김)",
        },
      },
    },
  },
  en: {
    translation: {
      nav: {
        services: "Solutions",
        certbear: "SSL Solution",
        about: "About",
        usecases: "Use Cases",
        process: "Process",
        results: "Results",
        contact: "Contact",
        partner: "Partners",
        dashboard: "Dashboard",
        admin: "Admin",
        adminSalesReps: "Sales reps",
        profile: "My account",
        notices: "Notices",
        logout: "Sign out",
        logoutDone: "Signed out.",
      },
      hero: {
        eyebrow: "BetweenSoft",
        title: "Make enterprise operations\nsafer and more resilient",
        desc:
          "SSL certificate management, middleware operations, API reliability, and web system delivery.\n" +
          "BetweenSoft is the technology partner that reduces downtime risk and raises operational quality.",
        cta1: "Start a project",
        cta2: "See solutions",

        techTitle: "Core Technology Areas",
        version: "v1.0",

        m1Label: "Security · Certificates",
        m1Value: "CertBear SSL Lifecycle Management",
        m1Hint: "Collection · Monitoring · Automated Renewal",

        m2Label: "Enterprise Middleware",
        m2Value: "Official TmaxSoft Partner",
        m2Hint: "JEUS · WebtoB 구축/마이그레이션/운영",

        m3Label: "Platform · Operations",
        m3Value: "API Architecture & Operational Enhancement",
        m3Hint: "Metrics-based Monitoring · Performance Optimization",

        workTitle: "Key Projects",

        w1: "SSL Certificate Centralized Management",
        w2: "Middleware Implementation & Operations",
        w3: "Corporate Website Renewal",
        w4: "Back-office / Admin Systems",
        w5: "API / Server Development",

        note: "* We prioritize stable operations over rushed delivery.",
      },
      services: {
        note: "* Scope and deliverables can be tailored based on project nature and operational environment.",
        moreTitle: "Featured technology support",
        moreDesc:
          "Alongside the core solutions, a broader set of technology areas we support per your environment.",
        flagshipBadge: "Flagship",
        popover: {
          close: "Close",
          keywords: "Keywords",
          detailFallback: "Details",
        },
        items: {
          tmax: {
            title: "Official TmaxSoft Partner",
            desc: "We support stable enterprise environments with hands-on implementation and operations experience on Tmax products.",
            tags: ["Enterprise", "Integration", "Operations"],
            extra: {
              headline: "Implementation & Ops",
              bullets: [
                "Enterprise migration / environment transition experience",
                "Incident response, performance tuning, and ops process design",
                "Integration support (SSO, authentication, authorization, etc.)",
              ],
            },
          },
          certbear: {
            title: "CertBear SSL Certificate Solution",
            desc: "Centralize collection, monitoring, and renewal to prevent expiry incidents and reduce security risk.",
            tags: ["SSL/TLS", "Automation", "Dashboard"],
            extra: {
              headline: "Key capabilities",
              bullets: [
                "Automatic expiry alerts",
                "Renewal automation & workflows",
                "Asset management with dashboards",
              ],
            },
          },
          netfunnel: {
            title: "STC Lab API NetFUNNEL",
            desc: "Control and queue API traffic in real time to prevent overload, and ensure stable processing with priority-based routing.",
            tags: ["Traffic Control", "Queuing", "Priority"],
            extra: {
              headline: "Benefits",
              bullets: [
                "Protect infrastructure by admitting or queuing requests based on resource thresholds",
                "Guarantee QoS with business/client priority rules",
                "Operational visibility with per-API traffic and queue monitoring",
              ],
            },
          },
          everpure: {
            title: "Everpure (ex-PureStorage) Implementation & Operations",
            desc: "From design and procurement to migration and operational optimization—tailored to your environment.",
            tags: ["Storage", "Migration", "Ops"],
            extra: {
              headline: "Scope",
              bullets: [
                "Design / rollout / migration",
                "Operational standardization & optimization",
                "Monitoring & performance analysis",
              ],
            },
          },
          elastic: {
            title: "Elasticsearch",
            desc: "Design pipelines and operate clusters for fast and reliable logging, search, and analytics.",
            tags: ["Search", "Observability", "Scale"],
            extra: {
              headline: "Build & run",
              bullets: [
                "Cluster design and tuning",
                "Log/search pipeline setup",
                "Observability integration (monitoring/alerting)",
              ],
            },
          },
          oss: {
            title: "Open-source & Middleware Support",
            desc: "Maintenance and technical support—plus governance and contribution workflows for sustainable adoption.",
            tags: ["OpenSource", "Maintenance", "Governance"],
            extra: {
              headline: "Process",
              bullets: [
                "Usage/validation policies",
                "Vulnerability response & version management",
                "Contribution & review workflow enablement",
              ],
            },
          },
          renewal: {
            title: "Website Renewal",
            desc: "Clarify brand messaging and information architecture with responsive UI, performance, and SEO in mind.",
            tags: ["UI/UX", "SEO", "Performance"],
            extra: {
              headline: "Improvements",
              bullets: [
                "Content & information architecture",
                "Responsive UI/UX refinement",
                "Performance & SEO optimization",
              ],
            },
          },
        },
      },
      certbear: {
        badge: "SSL Certificate Solution",
        title: "CertBear — manage certificates reliably",
        desc: "CertBear helps manage the SSL certificate lifecycle (issuance/renewal/deployment/expiry tracking) to reduce operational risk and prevent outages.",
        cta1: "Contact about certBear",
        cta2: "See services",
        p1: "Expiry alerts",
        p2: "Ops automation",
        p3: "Dashboard",
        cardTitle: "Key features",
        f1t: "Expiry tracking & alerts",
        f1d: "Track expiration dates and get early alerts to avoid downtime.",
        f2t: "Standardized issuance/renewal",
        f2d: "Streamline workflows and improve handover and governance.",
        f3t: "Operational visibility",
        f3d: "See status at a glance and take action faster.",
        noteTitle: "Adoption",
        note: "We tailor the scope to your environment (web servers, load balancers, issuance method) and can integrate with CI/CD and Docker.",

        section: {
          ariaLabel: "CertBear SSL Certificate Solution",

          chip1: "SSL Certificate Solution",
          chip2: "CertBear",

          title1: "SSL/TLS certificates,",
          title2: "collection · monitoring · renewal — all in one place",

          p1: "To adapt to the shorter SSL/TLS certificate validity periods,\nwe developed our own automated certificate management technology.",
          p2: "Without complex manual work, we centrally manage <b>collection, monitoring, and renewal</b> to fundamentally prevent outages and security risks.",

          points: [
            { title: "Prevent expiry incidents", desc: "Expiry tracking + early alerts" },
            { title: "Ops automation", desc: "Standardize renewal workflows" },
            { title: "Visibility", desc: "Status at a glance via dashboard" },
            { title: "Risk reduction", desc: "Proactive response to outages/security issues" },
          ],

          cta1: "Contact about SSL solution",
          cta2: "See services",

          stats: [
            { k: "Collection", v: "Auto discovery" },
            { k: "Monitoring", v: "Status / expiry" },
            { k: "Renewal", v: "Standard workflow" },
          ],

          imageAlt: "CertBear UI preview",

          floating: {
            label: "CertBear",
            title: "SSL automation",
          },

          features: [
            {
              title: "Certificate inventory",
              desc: "Automatically collect and standardize certificate status per service/domain into a managed inventory.",
            },
            {
              title: "Expiry & risk alerts",
              desc: "Detect expiring certificates, errors, and misconfigurations early to secure response time.",
            },
            {
              title: "Operational governance",
              desc: "Organize issuance/renewal processes to simplify handover and reduce repetitive work.",
            },
          ],

          featureNote:
            "* If needed, we can extend the scope to match your environment (web servers, load balancers, issuance methods).",
        },
      },
      process: {
        steps: [
          {
            n: "01",
            title: "Requirements",
            desc: "Align goals, scope, and priorities to establish a single baseline.",
          },
          {
            n: "02",
            title: "Planning & Architecture",
            desc: "Define user flows and data structure, and forecast schedule and risks.",
          },
          {
            n: "03",
            title: "Design & UI",
            desc: "Design components that reflect brand tone and refine usability.",
          },
          {
            n: "04",
            title: "Development & Testing",
            desc: "Implement and validate features with stability and performance in mind.",
          },
          {
            n: "05",
            title: "Release & Operations",
            desc: "Standardize delivery with CI/CD and stabilize for your runtime environment.",
          },
          {
            n: "06",
            title: "Monitoring & Improvement",
            desc: "Detect issues quickly with metrics and logs, and continuously improve.",
          },
        ],
      },
      footer: {
        desc:
          "BetweenSoft specializes in enterprise IT infrastructure implementation and operations.\n" +
          "We support your IT environment with reliable technology and trust.",

        linksTitle: "Links",
        links: {
          about: "About",
          services: "Services",
          certbear: "SSL Solution",
          contact: "Contact",
        },

        contactTitle: "Contact",
        mailNote: "* Email inquiries welcome",

        bottom: {
          top: "Top",
          contact: "Contact",
          rights: "All rights reserved.",
        },
      },
      trustbar: {
        flagshipLabel: "Flagship",
        flagshipName: "CertBear",
        flagshipDesc: "SSL certificate lifecycle automation",
        partner: "Official TmaxSoft Partner",
        coverage: "Coverage",
        items: ["JEUS", "WebtoB", "SSL/TLS", "API", "DevOps"],
        tagline: "An operations-first technology partner",
      },
      usecases: {
        eyebrow: "Use Cases",
        title: "Problems we solve",
        desc: "We structurally reduce the risks teams hit most often in operations.",
        items: [
          {
            title: "Prevent certificate-expiry incidents",
            desc: "Expiry tracking, early alerts, and renewal automation prevent outages.",
          },
          {
            title: "Stabilize heavy API traffic",
            desc: "Threshold/priority-based queuing protects critical requests under peak load.",
          },
          {
            title: "Modernize legacy middleware ops",
            desc: "JEUS·WebtoB standardization, tuning, and incident response improve predictability.",
          },
          {
            title: "Admin / back-office renewal",
            desc: "Reworked information architecture and UI/UX improve operational speed and accuracy.",
          },
        ],
      },
      results: {
        eyebrow: "Results",
        title: "The change we delivered",
        desc: "Given the enterprise context where exact figures can’t be disclosed, we summarize representative improvements qualitatively.",
        items: [
          {
            title: "JEUS·WebtoB operations stabilized",
            desc: "Established incident response and operational standards to make the middleware environment more predictable.",
          },
          {
            title: "SSL certificate management standardized",
            desc: "Turned collection, monitoring, and renewal into a process to structurally reduce expiry-incident risk.",
          },
          {
            title: "Admin / back-office renewal",
            desc: "Reorganized information architecture and UI/UX to improve the speed and accuracy of operational work.",
          },
          {
            title: "API response reliability improved",
            desc: "Introduced traffic control and monitoring to protect critical requests even under peak load.",
          },
        ],
        note: "* Per client confidentiality, specific figures and client names are not shown.",
      },
      section: {
        servicesTitle: "Core Solutions",
        servicesDesc:
          "We provide the core technology to run enterprise services—from preventing certificate-expiry incidents to API traffic protection, JEUS·WebtoB operations, and back-office delivery.",
        processTitle: "Process",
        processDesc: "Reduce waste, improve timeline and quality.",
        aboutTitle: "BetweenSoft",
        aboutDesc:
          "We design around your environment and implement structures that reduce operational risk. We prioritize stable operations over rushed delivery and build standardized, handover-ready processes.",
        contactTitle: "Let’s design your next project together",
        contactDesc:
          "Even a short brief is enough. We’ll quickly propose a direction that fits your environment and goals.",
        contact: {
          submit: "Send inquiry",
          submitting: "Sending...",
          mailto: "Send via email",
          fields: {
            company: "Company",
            companyPlaceholder: "BetweenSoft",
            name: "Name *",
            inquiryType: "Inquiry type",
            phone: "Phone",
            phonePlaceholder: "010-1234-5678",
            email: "Email *",
            emailPlaceholder: "example@company.com",
            message: "Message *",
            messagePlaceholder: "Briefly describe your needs.",
          },
          validationRequired: "Please enter your name, email, and message.",
          validationEmail: "Please check the email format.",
          submitted: "Your inquiry was received. We’ll get back to you shortly.",
          submitFailed: "Failed to submit the inquiry. Please try again later.",
          note: "* Name and message are required. Submission saves to the database and triggers an email notification.",
        },
      },
      about: {
        snapshotTitle: "Company Snapshot",
        snapshotNote: "* Tech stack customized per client.",
        info: {
          commTitle: "Clear communication",
          commDesc: "Documentation and weekly syncs reduce risk.",
          maintainTitle: "Maintainability first",
          maintainDesc: "We favor structures that minimize tech debt.",
          perfTitle: "Performance / SEO",
          perfDesc: "Improvements driven by Core Web Vitals.",
          securityTitle: "Security fundamentals",
          securityDesc: "Auth, permissions, and logging — the basics, done right.",
        },
        snapshot: {
          engineering: "Engineering",
          development: "Development",
          collab: "Collaboration",
          deploy: "Deployment",
          contact: "Contact",
        },
      },
      partners: {
        eyebrow: "Partners",
        title: "Partners we grow with",
        desc: "Verified partnerships and collaborations lift both operational stability and technical depth for our customers.",
        tmaxBadge: "Official",
        tmaxTitle: "Official TmaxSoft Partner",
        tmaxDesc:
          "We deliver implementation, migration, and operations for the enterprise middleware JEUS and WebtoB as an official partner.",
        tmaxScopeTitle: "Scope of collaboration",
        tmaxScope: [
          "JEUS implementation, tuning, migration",
          "WebtoB installation and web traffic stabilization",
          "Incident response and operations automation",
          "Official technical-support channel",
        ],
        inquireTitle: "Partnership & collaboration",
        inquireDesc:
          "Open to technical partnership, joint go-to-market, and product integration. Send us a short brief and we’ll get back quickly.",
        inquireCta: "Get in touch",
        backCta: "Back to home",

        // === Self-service area (mockup) ===
        login: {
          title: "Partner Sign in",
          subtitle: "Sign in to register and manage deals.",
          loginId: "Login ID",
          loginIdPlaceholder: "Login ID",
          password: "Password",
          passwordPlaceholder: "Password",
          submit: "Sign in",
          submitting: "Signing in…",
          signupPrompt: "Not a partner yet?",
          signupLink: "Apply to become a partner",
          forgotPassword: "Forgot password",
          alreadyLoggedIn: "You are already signed in.",
          toDashboard: "Go to dashboard",
          toAdmin: "Go to admin",
          invalid: "Check your ID or password.",
        },
        passwordReset: {
          title: "Password reset",
          requestDesc:
            "Enter your Login ID. We will send a reset link to the email registered on that account.",
          requestSubmit: "Send reset email",
          requestSent: "A reset email has been sent. Please check your inbox.",
          confirmSendTitle: "Send reset email",
          registeredEmailLabel: "Registered email",
          confirmSendDesc: "We will send a password reset email to this address.",
          confirmSendOk: "Confirm",
          confirmSendCancel: "Cancel",
          confirmDesc: "Enter your new password. (8+ characters)",
          confirmSubmit: "Change password",
          confirmSuccess: "Password changed. Please sign in with the new password.",
          submitting: "Submitting…",
          backToLogin: "Back to sign-in",
          loginId: "Login ID",
          newPassword: "New password",
          confirmPassword: "Confirm password",
          passwordHint: "8+ characters; mix of letters, digits, symbols recommended",
          errors: {
            loginIdRequired: "Login ID is required.",
            userNotFound: "This ID is not registered.",
            passwordTooShort: "Password must be at least 8 characters.",
            passwordMismatch: "Passwords do not match.",
            tokenInvalid: "Reset token is invalid or expired. Please request again.",
            requestFailed: "Request failed. Please try again later.",
            confirmFailed: "Failed to change password.",
          },
        },
        signup: {
          title: "Partner sign-up request",
          desc: "After submission, an administrator will review the request. Typically 2–4 business days.",
          sectionCompany: "Company information",
          sectionContact: "Sales rep information",
          sectionAccount: "Account",
          sectionTerms: "Agreements",
          fields: {
            loginId: "Login ID",
            loginIdPlaceholder: "Lowercase letters · 4-30 chars",
            loginIdHint:
              "Lowercase letters / digits / underscore. Must start with a letter. 4-30 chars.",
            companyName: "Company name",
            businessNumber: "Business registration number",
            businessNumberPlaceholder: "10 digits",
            representativeName: "Representative name",
            companyEmail: "Company email",
            industry: "Industry",
            address: "Address",
            addressPlaceholder: "Set via address search",
            addressSearch: "Search address",
            addressSearchTitle: "Search address",
            addressDetailPlaceholder: "Detail address (building, floor, unit)",
            salesRepHeadcount: "Sales rep headcount",
            techSupportHeadcount: "Tech support headcount",
            headcountPlaceholder: "people (optional)",
            contactName: "Sales rep name",
            contactTitle: "Sales rep title",
            contactEmail: "Email",
            contactPhone: "Mobile",
            contactPhonePlaceholder: "010-1234-5678",
            password: "Password",
            passwordHint: "8+ chars, letters + digits + special",
            passwordConfirm: "Confirm password",
            companyBrochure: "Company brochure",
            companyBrochureHint: "PDF · DOC · PPT · HWP. Up to 10 MB. Optional.",
            businessRegistration: "Business registration certificate",
            bankbook: "Bankbook copy",
            docImageHint: "PDF · JPG · PNG · HEIC. Up to 10 MB. Optional.",
            attach: "Choose file",
            attached: "Attached",
            removeFile: "Remove",
          },
          loginIdStatus: {
            checking: "Checking…",
            available: "Available.",
            taken: "This ID is already taken.",
            invalid: "Invalid format.",
          },
          terms: {
            service: "Agree to the service terms (required)",
            privacy: "Agree to personal data collection & use (required)",
            marketing: "Agree to marketing emails (optional)",
            viewDetail: "Read full text",
            viewSoon: "Full text is coming soon.",
          },
          errors: {
            required: "This field is required.",
            loginId:
              "Login ID must be 4-30 chars, start with a lowercase letter, contain letters/digits/underscore only.",
            email: "Invalid email format.",
            phone: "Invalid phone number.",
            businessNumber: "Business number must be 10 digits.",
            businessNumberInvalid: "Invalid business number (checksum failed).",
            password: "Password does not meet the policy.",
            passwordMismatch: "Passwords do not match.",
            terms: "You must agree to the required terms.",
            companyRequired: "Search for and select your company.",
            fileSize: "File exceeds the 10 MB limit.",
            fileType: "Unsupported file format.",
            serverError: "Request failed. Please try again later or contact support.",
          },
          existingPartnerNotice:
            "This company is already registered. Your request will be reviewed as an additional contact for the existing company.",
          kind: {
            title: "Sign-up type",
            company: "New company",
            companyDesc:
              "Your company is not registered yet. Submit company details and documents.",
            member: "Existing company",
            memberDesc:
              "You are a sales rep of an already registered company. Find and select the company, then enter only your account and sales rep details.",
          },
          member: {
            sectionCompany: "Your company",
            searchLabel: "Search company name",
            searchPlaceholder: "At least 2 characters",
            searchHint:
              "Only registered partners are listed. If yours is not found, choose 'New company'.",
            searching: "Searching…",
            searchFailed: "Search failed. Please try again shortly.",
            noResult: "No results. Check the company name or choose 'New company'.",
            companyLabel: "Company name",
            selectedHint: "Company details are used as registered.",
            change: "Search again",
            contactHint:
              "Your account is created with these details and registered as this account's first sales rep. You can add more sales reps under [Company info] after sign-up.",
          },
          submit: "Submit",
          submitting: "Submitting…",
          doneTitle: "Your request was received",
          doneDesc: "We will follow up after review.",
        },
        pending: {
          title: "Pending approval",
          desc: "Your sign-up request was received. We will follow up within 1–2 business days.",
          close: "Close",
          viaTokenHint:
            "This page is shown temporarily right after submission. Once closed, you will need to sign in after approval to see it again.",
          memberHint: "Once approved, you can sign in with an account of {{company}}.",
        },
        dashboard: {
          greet: "Hello, {{company}} · {{name}}",
          featured: { tag: "Notice", view: "View" },
          kpi: {
            total: "Total deals",
            inProgress: "In progress",
            adoption: "Adoption",
            lost: "Lost",
            underReview: "Under review",
          },
          addDeal: "+ New deal",
          viewPerformance: "View performance",
          searchDeals: "Search deals",
          editCompany: "Company info",
          filters: {
            all: "All",
            // ko 와 같은 이유로 짧게 — 형제 탭(Proposal·Adoption·Lost)과 길이를 맞춘다.
            // 배지(partners.deals.review.pending)는 "Under review" 그대로 둔다.
            pending: "Review",
            brochure_sent: "Brochure sent",
            intro: "Intro",
            prelim_quote: "Prelim quote",
            poc: "PoC",
            proposal: "Proposal",
            adoption: "Adoption",
            lost: "Lost",
            rejected: "Rejected",
            searchPlaceholder: "Search project, customer, or registrant",
          },
          table: {
            projectName: "Project",
            customer: "Customer",
            registeredBy: "Registered by",
            poAmount: "Expected PO",
            poDate: "Expected PO date",
            status: "Status",
            createdAt: "Created",
          },
          empty: "No deals registered.",
        },
        profile: {
          title: "My account",
          back: "← Dashboard",
          sectionInfo: "Account",
          sectionPassword: "Change password",
          loginId: "Login ID",
          email: "Email",
          emailHint: "Ask an administrator to change your email.",
          name: "Name",
          phone: "Phone",
          salesRepHint:
            "Sales rep details shown on deals are managed separately in the sales rep list under [Company info].",
          save: "Save",
          saved: "Saved.",
          saveFailed: "Could not save. Please try again shortly.",
          loadFailed: "Could not load your account.",
          loadFailedHint:
            "Your account could not be loaded, so it cannot be edited right now. Please try again shortly.",
          retry: "Reload",
          noChanges: "Nothing has changed.",
          nameRequired: "Please enter your name.",
          currentPassword: "Current password",
          newPassword: "New password",
          newPasswordConfirm: "Confirm new password",
          passwordRule: "At least 8 characters with a letter, a number and a symbol",
          passwordMismatch: "The new passwords do not match.",
          currentPasswordRequired: "Please enter your current password.",
          currentPasswordWrong: "Your current password is incorrect.",
          changePassword: "Change password",
          passwordChanged: "Your password has been changed.",
        },
        edit: {
          title: "Edit company info",
          back: "Back",
          sectionBasics: "Basic info",
          companyEmailHint:
            "Your company's main email. Notice emails are sent to each account's email.",
          companyEmailInvalid: "Enter a valid company email.",
          sectionCompany: "Company size",
          sectionSalesReps: "Sales reps",
          sectionTechSupports: "Tech support",
          addSalesRep: "+ Add a sales rep",
          addTechSupport: "+ Add a tech support member",
          removeRow: "Remove",
          salesRepScopeHint:
            "Sales reps for your account only. They are not shared with other accounts in your company.",
          saved: "Saved.",
          saveFailed: "Save failed",
          loadFailed: "Failed to load info.",
          nameRequired: "Name is required.",
          empty: "No rows yet. Use + to add.",
          rowName: "Name",
          rowTitle: "Title",
          rowPhone: "Phone",
          rowEmail: "Email",
          save: "Save",
        },
        common: {
          loading: "Loading…",
        },
        dealSearch: {
          title: "Search deals",
          subtitle: "Search company-wide deals by project name or customer.",
          backToDashboard: "Back to dashboard",
          searchPlaceholder: "Project or customer name",
          initialTitle: "Type to start searching",
          initialDesc: "Search by part of a project name or customer company.",
          emptyTitle: "No matching deals",
          emptyDesc: "Try a different keyword.",
          mineTag: "(our company)",
          privacyNote:
            "Partner names from other companies are masked for privacy. Only your own company's deals show the full name.",
          table: {
            projectName: "Project",
            customer: "Customer",
            partner: "Partner",
            status: "Stage",
          },
        },
        notices: {
          title: "Notices",
          subtitle: "Check announcements and resources from BetweenSoft.",
          backToDashboard: "Back to dashboard",
          searchPlaceholder: "Search by title",
          emptyTitle: "No notices yet",
          emptyDesc: "New notices will appear here.",
          pinnedTag: "Pinned",
          table: {
            title: "Title",
            author: "Author",
            createdAt: "Created",
            views: "Views",
            attachments: "Files",
          },
          detail: {
            backToList: "Back to list",
            author: "Author",
            createdAt: "Created",
            views: "Views",
            attachments: "Attachments",
            noAttachments: "No attachments.",
            notFound: "Notice not found.",
            loadFailed: "Failed to load notice.",
            downloadFailed: "Download failed.",
          },
        },
        performance: {
          title: "Performance · {{company}}",
          period: { m3: "Last 3 mo", m6: "Last 6 mo", m12: "Last 12 mo" },
          exportCsv: "Export CSV",
          exportSoon: "CSV export is coming soon.",
          adminBanner: "Admin mode — viewing {{company}} data",
          adminBannerBack: "Back to admin",
          kpi: {
            total: "Total registered",
            inProgress: "In progress",
            adoption: "Adoption",
            lost: "Lost",
            poAmount: "Cumulative expected PO",
          },
          charts: {
            byQuarter: "Registrations by quarter",
            byStatus: "Sales stage distribution",
            topCustomers: "Top 5 customers",
            recentActivity: "Recent activity",
            statusLabel: "Status",
          },
          emptyTitle: "Nothing to show yet",
          emptyDesc: "Register a deal to see performance analytics.",
          emptyCta: "Register a deal",
        },
        deals: {
          form: {
            project: "Project",
            projectName: "Project name",
            sectionCustomer: "Customer",
            sectionPartner: "Partner",
            sectionDeal: "Deal information",
            customerCompany: "Customer company",
            customerCompanySearchPlaceholder: "Search by company name (2+ chars)",
            customerCompanySearching: "Searching…",
            customerCompanyNoResults: "No results",
            customerCompanyChange: "Change",
            customerCompanyHint: "Search and select from the list (no manual entry)",
            customerCompanyMustSelect:
              "You must pick a company from the list — typing alone is not saved",
            customerCompanyChecking: "Checking…",
            customerCompanyTaken: "This customer is already registered — cannot be selected",
            customerCompanyTakenAlertTitle: "This customer is already registered",
            customerCompanyTakenAlertBody: "Please contact the distributor (BetweenSoft).",
            customerCompanyTakenAlertOk: "OK",
            customerCompanyCorp: "Corp",
            customerCompanyIndividual: "Individual",
            customerBusinessNumber: "Customer business no.",
            customerBusinessNumberHint:
              "The leading digits come from the lookup. Add the rest if you know them — optional, and it helps confirm whether the customer is already claimed.",
            customerBusinessNumberSuspicious:
              "Please double-check the business number. You can still submit as is.",
            customerBusinessNumberNone:
              "The lookup result has no business number. You can register without it.",
            customerBusinessNumberRef: "reference",
            similarCustomer: "{{count}} similar customer(s) found",
            similarCustomerMore: "and {{count}} more",
            similarCustomerHint:
              "You can still register. Please confirm it is not the same customer.",
            customerContactName: "Contact name",
            customerContactPosition: "Contact title",
            customerPhone: "Mobile",
            customerEmail: "Email",
            partnerCompany: "Partner company",
            salesRepName: "Sales rep name",
            salesRepHint: "Pick from sales reps registered in Company info.",
            salesRepSelect: "Select a sales rep",
            salesRepEmptyHint: "No sales reps registered. Please add one in Company info.",
            salesRepDeleted: "Deleted sales rep — please reselect",
            salesRepPhone: "Mobile",
            salesRepEmail: "Email",
            poExpected: "Expected PO timing",
            poQuarter: "Quarter",
            quarterAuto: "Auto-derived from go-live date",
            poDate: "Go-live",
            poDatePlaceholder: "Pick a date",
            productDetail: "Target environment",
            productDetailPlaceholder: "e.g., hardware, OS, middleware, etc.",
            poAmount: "Expected PO amount (KRW)",
            poAmountPlaceholder: "e.g., 10,000,000",
            vatExcluded: "VAT excluded",
            salesProgress: "Sales progress notes",
            salesProgressPlaceholder:
              "e.g., webserver type (Apache, Tomcat, WebtoB, IIS, etc.)\ne.g., SSL-using equipment: L7, WAF, encryption/decryption, visibility, etc.\ne.g., current SSL certificate name and quantity\ne.g., redundancy / network segregation\ne.g., server OS: Linux, Windows, etc.\ne.g., other notes: customer requirements",
            channel: "Partner channel",
            poc: "PoC needed?",
            pocRequired: "Required",
            pocNotRequired: "Not required",
            pocUndecided: "Undecided",
            brochure: "Brochure delivered",
            submit: "Submit",
            submitting: "Submitting…",
            requestReview: "Request review",
            requestingReview: "Requesting review…",
            reviewRequested:
              "Review requested. The deal appears in the deal list once an administrator approves it.",
            createFailed: "Failed to register deal.",
          },
          blocked: {
            title: "Deal registration blocked",
            body: "Deal registration is currently unavailable. Please contact the administrator.",
            ok: "OK",
          },
          status: {
            brochure_sent: "Brochure sent",
            intro: "Intro",
            prelim_quote: "Prelim quote",
            poc: "PoC",
            proposal: "Proposal",
            adoption: "Adoption",
            lost: "Lost",
          },
          review: {
            label: "Review status",
            pending: "Under review",
            approved: "Approved",
            rejected: "Rejected",
          },
          detail: {
            statusLabel: "Sales stage",
            reviewPendingBanner: "Under review — it appears in the deal list once approved",
            reviewPendingHint:
              "Until approved, this deal is excluded from the deal list, statistics and performance. You can keep editing it.",
            reviewRejectedBanner: "Rejected and deleted — view only",
            reviewRejectedReason: "Rejection reason",
            reviewRejectedHint:
              "This deal cannot be edited or restored. Address the reason and register a new deal.",
            registerAgain: "Register a new deal",
            readOnlyNotOwner:
              "Owned by {{name}}. Only the owner account can edit or delete this deal, so it is view only.",
            registeredBy: "Registered by",
            ownedBy: "Owner",
            registeredAt: "Registered at",
            // count = 경과일. i18next 복수형(_zero/_one/_other)
            lastUpdated_zero: "Last updated {{date}} (today)",
            lastUpdated_one: "Last updated {{date}} ({{count}} day ago)",
            lastUpdated_other: "Last updated {{date}} ({{count}} days ago)",
            requestEdit: "Edit",
            requestEditSoon: "Edit feature is coming soon.",
            cancel: "Cancel",
            backToList: "Back to list",
            adminMemo: "Admin internal memo",
            adminStatus: "Change sales stage",
            notFound: "Deal not found or you do not have access.",
            vatNote: "(VAT excluded)",
            save: "Save",
            statusChanged: "Sales stage updated.",
            statusChangeFailed: "Failed to change sales stage.",
            statusChangeConfirmTitle: "Change sales stage",
            statusChangeConfirmContent: "Change sales stage from '{{from}}' to '{{to}}'?",
            statusChangeConfirmOk: "Change",
            statusChangeConfirmCancel: "Cancel",
            edit: "Edit",
            editSaved: "Changes saved.",
            editSaveFailed: "Failed to save changes.",
            delete: "Delete deal",
            dangerZone: "Danger zone",
            deleteSectionTitle: "Delete this deal",
            deleteSectionHint:
              "Deleted deals disappear from lists, search, and performance. Deletion cannot be undone. Please decide carefully.",
            deleteConfirmTitle: "Delete this deal?",
            deleteConfirmContent:
              "Deleted deals no longer appear in lists, search, or performance. Please decide carefully.",
            deleteConfirmOk: "Delete",
            deleteConfirmCancel: "Cancel",
            deleteReasonPlaceholder:
              "Reason for deletion (optional, max 500 chars) — shown in the admin deleted-deals list",
            deletedBanner: "Deleted deal — read only",
            deletedMeta: "Deleted on: {{at}} · Deleted by: {{by}}",
            deletedReasonLabel: "Deletion reason",
            deletedNoReason: "(no reason entered)",
            deleteDone: "Deal deleted.",
            deleteFailed: "Failed to delete deal.",
            memoSaved: "Memo saved.",
            memoSaveFailed: "Failed to save memo.",
            memoSaving: "Saving...",
            adminMemoHint: "Internal only · not visible to partners",
            adminMemoPlaceholder: "Record customer notes, internal remarks, etc.",
            partnerMemo: "Partner memo",
            partnerMemoLabel: "Memo (for admin)",
            partnerMemoPlaceholder: "Optional note for the admin",
            messages: {
              titleAdmin: "Messages to partner",
              titlePartner: "Messages from admin",
              hintAdmin:
                "Visible to the partner · an email notification is sent to the sales rep when posted",
              hintPartner: "Messages left on this deal by the BetweenSoft admin",
              placeholder: "Enter feedback or requests for the partner",
              send: "Send message",
              sending: "Sending...",
              empty: "No messages yet.",
              recipient: "Notify: {{email}}",
              noRecipientHint: "No sales rep email — the notification email will not be sent",
              unknownAuthor: "(unknown)",
              adminActor: "Admin",
              mailStatus: {
                sent: "Sent",
                failed: "Failed",
                no_recipient: "No recipient",
                pending: "Unconfirmed",
              },
              sentOk: "Message saved and notification email sent.",
              savedMailFailed: "Message saved, but the notification email failed.",
              savedNoRecipient: "Message saved. No sales rep email, so no notification was sent.",
              savedMailUnknown: "Message saved. The notification result could not be confirmed.",
              sendFailed: "Failed to send message",
              required: "Please enter a message.",
            },
            quotation: "Quotation",
            quotationUpload: "Upload",
            quotationReplace: "Replace",
            quotationUploading: "Uploading…",
            quotationUploaded: "Quotation uploaded.",
            quotationUploadFailed: "Failed to upload quotation.",
            quotationDownloadFailed: "Failed to download quotation.",
            adoptionFiles: "Adoption documents",
            adoptionFilesHint: "Contracts, quotations and other proof of adoption.",
            adoptionFilesManageHint:
              "Only the person who marked the deal as adopted can replace them.",
            adoptionRequiredHint:
              "To move to Adoption, upload at least one document such as a contract or quotation.",
            adoptionExistingHint:
              "{{count}} document(s) already uploaded — you can proceed without adding more.",
            adoptionFilesLabel: "Documents (required)",
            adoptionPick: "Choose files",
            adoptionPickHint:
              "PDF, Office, HWP, images, ZIP · {{maxSizeMb}}MB each · up to {{maxFiles}} files",
            adoptionRemovePending: "Remove",
            adoptionAdd: "Add files",
            adoptionDelete: "Delete",
            adoptionDeleteConfirm: "Delete '{{name}}'? This cannot be undone.",
            adoptionMinLocked: "At least one document is required while in Adoption.",
            adoptionUploading: "Uploading…",
            adoptionAdded: "Documents added.",
            adoptionDeleted: "Document deleted.",
            adoptionFailed: "Failed to process documents.",
            adoptionDownloadFailed: "Failed to download file.",
            adoptionNone: "No documents uploaded.",
            adoptionTooMany: "You can upload up to {{max}} documents.",
            adoptionTooLarge: "'{{name}}' exceeds {{maxSizeMb}}MB.",
            adoptionBadType: "'{{name}}' is not a supported file type.",
          },
        },
      },
      common: {
        unitKrw: "KRW",
        unitCount: "deals",
        loading: "Loading…",
      },
      admin: {
        title: "Admin dashboard",
        featured: { tag: "Notice", view: "View" },
        tabs: {
          deals: "Deals",
          reviews: "Deal review",
          signups: "Sign-up requests",
          partners: "Partners",
          performance: "Partner performance",
          stale: "Deals to review",
          deleted: "Deleted deals",
          notices: "Notices",
          stats: "Statistics",
        },
        dealReviews: {
          subPending: "Pending",
          subDone: "Completed",
          submittedAt: "Submitted",
          company: "Partner",
          projectName: "Project",
          customer: "Customer",
          poAmount: "Expected PO",
          salesRep: "Sales rep",
          daysWaiting: "Waiting",
          days: "{{count}}d",
          action: "Review",
          result: "Result",
          reviewedAt: "Reviewed at",
          reviewedBy: "Reviewed by",
          reason: "Rejection reason",
          reasonView: "View reason",
          reasonTitle: "Rejection reason",
          approve: "Approve",
          reject: "Reject",
          emptyPending: "No deals are awaiting review.",
          emptyDone: "No deals have been reviewed yet.",
          searchPlaceholder: "Search partner, customer, or sales rep",
          searchEmpty: "No matches.",
          rejectedDeletedNote: "Deleted",
          rejectedMovedHint:
            "Both approved and rejected deals appear here. Rejected deals are also deleted, so they can be found in the Deleted deals tab as well.",
          approved: "Approved the deal for {{customer}}.",
          rejected: "Rejected the deal for {{customer}}.",
          alreadyReviewed:
            "Another administrator already handled this deal. The list has been reloaded.",
          actionFailed: "The action failed.",
          rejectReasonRequired: "Please enter a rejection reason.",
          rejectReasonLabel: "Rejection reason (sent to the partner as written)",
          rejectReasonPlaceholder:
            "Describe specifically what needs fixing. e.g. The quotation is missing.",
          confirmApprove: {
            title: "Approve this deal?",
            body: "Approving the {{customer}} deal from {{company}}.",
            hint: "Once approved it appears immediately in the deal list, statistics and performance. Approval cannot be undone.",
          },
          confirmReject: {
            title: "Reject deal",
            body: "Rejecting the {{customer}} deal from {{company}}.",
            preemptionWarning:
              "Rejecting releases the claim on this customer, so another partner can register a deal for the same customer.",
          },
        },
        deletedDeals: {
          deletedAt: "Deleted on",
          company: "Partner / Registered by",
          projectName: "Project",
          customer: "Customer",
          salesRep: "Sales rep",
          status: "Stage",
          deletedBy: "Deleted by",
          reason: "Reason",
          reasonView: "View",
          noReasonShort: "(no reason)",
          reasonTitle: "Deletion reason",
          noReason: "No deletion reason was entered.",
          rejectReason: "Rejection reason",
          reasonClose: "Close",
          empty: "No deleted deals.",
          searchPlaceholder: "Search partner, customer, or sales rep",
          searchEmpty: "No matches.",
        },
        partners: {
          title: "Partner companies",
          desc: "Blocking deal registration prevents the partner from creating new deals. Existing deals are unaffected.",
          company: "Partner",
          businessNumber: "Business no.",
          status: "Status",
          statusActive: "Active",
          statusInactive: "Inactive",
          statusSuspended: "Suspended",
          statusDeleted: "Deleted",
          deleteColumn: "Delete",
          delete: "Delete",
          deleting: "Deleting…",
          deletedMeta: "{{date}} · {{admin}}",
          deletedDeals: "{{count}} deleted",
          confirmDelete: {
            title: "Delete this partner?",
            body: "All accounts under {{company}} will no longer be able to sign in.",
            accounts: "Its {{count}} sign-in account(s) are deleted as well.",
            deals:
              "Its {{count}} deal(s) are deleted as well and remain viewable only in the Deleted deals tab.",
            hint: "Attachments and history are kept. This cannot be undone.",
            rejoin: "A deleted company can apply again with the same business number.",
            ok: "Delete",
            cancel: "Cancel",
          },
          deals: "Deals",
          dealPermission: "Deal registration",
          permitAllowed: "Allowed",
          permitBlocked: "Blocked",
          lastChanged: "{{date}} · by {{admin}}",
          searchPlaceholder: "Search company, business no., login ID, email",
          searchEmpty: "No matches.",
          noAccounts: "No accounts yet.",
          confirmBlock: {
            title: "Block deal registration?",
            body: "{{company}} will not be able to create new deals. Existing deals are unaffected.",
            ok: "Block",
            cancel: "Cancel",
          },
          toasts: {
            allowed: "Deal registration enabled for {{company}}.",
            blocked: "Deal registration blocked for {{company}}.",
            saveFailed: "Failed to save.",
            deleted: "{{company}} deleted. Its accounts can no longer sign in.",
            deletedWithDeals:
              "{{company}} deleted. Its {{count}} deal(s) are now in the Deleted deals tab.",
            deleteFailed: "Failed to delete.",
          },
        },
        accounts: {
          loginId: "Login ID",
          name: "Name",
          email: "Email",
          phone: "Phone",
          lastLogin: "Last login",
          changeEmail: "Change email",
          modalTitle: "Change email",
          newEmail: "New email",
          newEmailHint: "Password reset emails will be sent to this address.",
          save: "Save",
          cancel: "Cancel",
          toasts: {
            saved: "Account email updated.",
            saveFailed: "Failed to update email.",
            invalidEmail: "Invalid email format.",
          },
        },
        stats: {
          sectionSignups: "Sign-up requests",
          sectionByStage: "Deals by sales stage",
          kpi: {
            partners: "Total partners",
            activePartners: "Active partners",
            deals: "Total deals",
            inProgress: "In progress",
            poTotal: "Expected PO total",
          },
          signup: { pending: "Pending", approved: "Approved", rejected: "Rejected" },
          table: { stage: "Stage", distribution: "Distribution", count: "Count" },
          datasetSection: "Customer search dataset",
          datasetMonth: "Active data (month)",
          datasetMonthValue: "{{year}}-{{month}}",
          datasetRowCount: "Workplaces",
          datasetAutoAt: "Auto refresh",
          datasetLastChecked: "Last checked",
          datasetNever: "Never",
          datasetRefresh: "Refresh now",
          datasetRefreshing: "Refreshing…",
          datasetRefreshDone: "Updated to {{month}} data.",
          datasetRefreshKept: "Already on the latest data.",
          datasetRefreshSparse: "The new month's data isn't ready yet; keeping the current data.",
          datasetRefreshUnavailable:
            "Couldn't reach the data provider, so nothing was updated. Please try again shortly.",
          datasetRefreshFailed: "Refresh failed.",
          datasetPinned: "Pinned to a fixed month via NPS_DATASET_UUID; auto refresh is disabled.",
        },
        notices: {
          addNotice: "New notice",
          newTitle: "New notice",
          editTitle: "Edit notice",
          statusDraft: "Draft",
          statusPublished: "Published",
          pinnedTag: "Pinned",
          table: {
            title: "Title",
            status: "Status",
            author: "Author",
            createdAt: "Created",
            views: "Views",
            attachments: "Files",
          },
          form: {
            title: "Title",
            titlePlaceholder: "Enter the notice title",
            content: "Content",
            contentPlaceholder: "Enter the notice content",
            status: "Status",
            statusDraft: "Draft (hidden from partners)",
            statusPublished: "Published (visible to partners)",
            isPinned: "Pin to top of list",
            isFeatured: "Dashboard main notice (only one)",
            notifyPartners: "Email partners about this notice",
            notifyPartnersHint:
              "Sent to the email of each active partner account when registered as published.",
            attachments: "Attachments",
            attachmentsHint: "PDF, docs, images, zip — 10MB each, up to 10 files",
            addFiles: "Add files",
            newFiles: "Files to add",
            existingAttachments: "Attached files",
            remove: "Remove",
            submit: "Save",
            cancel: "Cancel",
          },
          toasts: {
            created: "Notice created.",
            createFailed: "Failed to create notice.",
            updated: "Notice updated.",
            updateFailed: "Failed to update notice.",
            deleted: "Notice deleted.",
            deleteFailed: "Failed to delete notice.",
            loadFailed: "Failed to load notice.",
            uploadFailed: "Failed to upload attachments.",
            attachmentRemoved: "Attachment removed.",
            attachmentRemoveFailed: "Failed to remove attachment.",
            required: "Enter a title and content.",
          },
          deleteConfirmTitle: "Delete this notice?",
          deleteConfirmContent: "Deleted notices and attachments cannot be recovered.",
          deleteConfirmOk: "Delete",
          deleteConfirmCancel: "Cancel",
          dangerZone: "Danger zone",
          deleteSectionTitle: "Delete this notice",
          deleteSectionHint: "Deleted notices and attachments cannot be recovered.",
          delete: "Delete notice",
        },
        filters: {
          searchPlaceholder: "Search",
          partner: "Partner",
          status: "Status",
          period: "Period",
          allPartners: "All partners",
          allStatus: "All status",
        },
        table: {
          partner: "Partner",
          projectName: "Project",
          customer: "Customer",
          poAmount: "Expected amount",
          poDate: "Expected date",
          status: "Status",
          createdAt: "Created",
          adminBadge: "Admin",
        },
        deals: {
          addDeal: "+ Add deal",
          editDeal: "Edit deal",
          newTitle: "Admin-created deal",
          editTitle: "Edit admin-created deal",
          sectionRegistrant: "Registrant",
          registrant: "Created by",
          adminCompany: "Admin company",
          representativeName: "Representative name",
          sectionSalesRep: "Sales rep info",
          salesRepName: "Sales rep name",
          salesRepPhone: "Sales rep phone",
          salesRepEmail: "Sales rep email",
          submitted: "Deal created.",
          updated: "Deal updated.",
          createFailed: "Failed to create deal.",
          updateFailed: "Failed to update deal.",
          loadFailed: "Failed to load deal.",
          backToList: "Back to list",
          editForbiddenPartnerDeal: "Partner-created deals cannot be edited from this page.",
          editForbiddenNotOwner: "You can only edit deals you created.",
          changeHistory: {
            title: "Change history",
            empty: "No changes recorded.",
            unknownUser: "(unknown)",
            partnerActor: "Partner",
            adminActor: "Admin",
            boolTrue: "Yes",
            boolFalse: "No",
            partnerCompany: "Partner",
            ownerAccount: "Owner account",
          },
          ownerChange: {
            button: "Change owner",
            title: "Change deal owner",
            currentPartner: "Current partner",
            currentSalesRep: "Current sales rep",
            currentMark: "current",
            partner: "Partner",
            partnerSelect: "Select a partner",
            salesRep: "Sales rep",
            salesRepSelect: "Select a sales rep",
            noSalesRep: "This partner has no sales reps.",
            ownerAccount: "Owner account: {{name}} ({{loginId}})",
            ownerInactive: "account inactive",
            account: "Owner account",
            accountSelect: "Select an owner account",
            accountHint:
              "This sales rep has no owner account. Select the account that will manage this deal.",
            noAccount: "This partner has no active accounts.",
            warning:
              "The whole deal, including messages and attachments, moves to the new partner and owner. The previous partner will no longer see it. The original registrant is kept.",
            loading: "Loading…",
            cancel: "Cancel",
            ok: "Change",
            submitting: "Changing…",
            done: "Deal owner changed.",
            failed: "Failed to change the deal owner.",
            loadFailed: "Failed to load the list.",
          },
        },
        signup: {
          searchPlaceholder: "Search company or contact",
          searchEmpty: "No matches.",
          loginId: "Login ID",
          company: "Company",
          contact: "Contact",
          email: "Email",
          submittedAt: "Submitted",
          status: "Status",
          statusPending: "Pending",
          statusApproved: "Approved",
          statusRejected: "Rejected",
          approve: "Approve",
          reject: "Reject",
          rejectReasonPlaceholder: "Enter rejection reason",
          confirmApprove: "Approve this request?",
          confirmReject: "Reject this request?",
          detailTitle: "Request detail",
          memberSignup: "Existing company",
          duplicateCompany: "Registered business no.",
          newCompany: "New company sign-up",
          memberSignupHint:
            "This request adds an account to {{company}}, which is already registered. Approving creates the applicant's account and registers the entered sales rep as that account's first sales rep. Company details stay as registered.",
          duplicateCompanyHint:
            "{{company}} is already registered with the same business number, so this cannot be approved as a new company. Reject it and ask the applicant to apply again via 'Existing company'.",
          approveSoon: "Mockup only — actions are logged to console.",
          type: "Type",
          businessNumber: "Business no.",
          representativeName: "Representative name",
          companyEmail: "Company email",
          industry: "Industry",
          address: "Address",
          salesRepHeadcount: "Sales rep headcount",
          techSupportHeadcount: "Tech support headcount",
          phone: "Mobile",
          termsService: "Service terms",
          privacyConsent: "Privacy consent",
          marketing: "Marketing consent",
          rejectReasonLabel: "Reason",
          brochureFallback: "Company brochure",
          downloadBrochure: "Download brochure",
          downloadBusinessRegistration: "Download business registration",
          downloadBankbook: "Download bankbook",
          toasts: {
            detailLoadFailed: "Failed to load signup detail.",
            approved: "Approved.",
            approveFailed: "Approval failed.",
            rejected: "Rejected.",
            rejectFailed: "Reject failed.",
            downloadFailed: "Download failed.",
          },
        },
        performance: {
          kpi: { partners: "Partners", active: "Partners with deals", poTotal: "Cumulative PO" },
          table: {
            partner: "Partner",
            totalDeals: "Total deals",
            inProgress: "In progress",
            adoption: "Adoption",
            lost: "Lost",
            poTotal: "Cumulative PO",
            lastActivity: "Last activity",
          },
        },
        staleDeals: {
          periodLabel: "Stalled for",
          bulk: {
            button: "Send notice emails",
            loading: "Checking recipients…",
            confirmTitle: "Send update-request notices in bulk",
            confirmSummary:
              "Check the deals to send. Deals for the same recipient are combined into one email. ({{deals}} candidates · {{recipients}} recipients)",
            selectAll: "Select all",
            selectedSummary: "{{deals}} deals selected · {{recipients}} recipients",
            noneSelected: "Select at least one deal to send.",
            skippedNote:
              "Excluded: already notified {{already}} · no reachable account (no email, suspended or deleted) {{noRecipient}}",
            notInListNote: "{{n}} selected deals are excluded because the list has changed.",
            nothingToSend: "Nothing to send. ({{skipped}} deals already notified)",
            tooManyResults: "More than {{max}} results. Please narrow your search.",
            confirmOk: "Send selected",
            confirmOkCount: "Send selected ({{n}})",
            toasts: {
              sent: "Sent {{mails}} emails covering {{deals}} deals.",
              partial: "Sent {{mails}}, failed {{failed}} — failed ones can be retried.",
              failed: "Bulk send failed.",
            },
          },
          notice: {
            colTitle: "Notice",
            send: "Send email",
            sending: "Sending…",
            sent: "Sent",
            confirmTitle: "Send update-request notice",
            confirmRecipient: "Recipient",
            previewLabel: "Email to be sent",
            confirmDesc: "It cannot be re-sent until the deal is updated.",
            confirmOk: "Send",
            confirmCancel: "Cancel",
            toasts: {
              sent: "Notice email sent.",
              alreadySent: "A notice was already sent for this deal.",
              noRecipient:
                "No reachable registered account (no email, or the account is suspended or deleted).",
              failed: "Failed to send the notice email.",
            },
          },
          excel: "Download Excel",
          excelDownloading: "Downloading…",
          excelFailed: "Failed to download the Excel file.",
          period: {
            "3d": "3 days",
            "5d": "5 days",
            "1w": "1 week",
            "2w": "2 weeks",
            "3w": "3 weeks",
            "1m": "1 month",
            "2m": "2 months",
            "3m": "3 months",
          },
          count: "{{n}} deals",
          daysAgo: "{{days}}d stalled",
          empty: "No in-progress deals have stalled for this period.",
          searchPlaceholder: "Search partner, customer, or sales rep",
          searchEmpty: "No matches.",
          table: {
            company: "Partner/Owner",
            projectName: "Project",
            customer: "Customer",
            salesRep: "Sales rep",
            status: "Stage",
            lastUpdated: "Last change",
            daysSince: "Days stalled",
          },
          setting: {
            title: "Automatic alert",
            desc: "Every day at the set time, in-progress deals that have stalled (no changes) beyond the threshold are emailed to active admins. (Adoption/Lost deals are excluded.)",
            enabled: "Enable automatic sending",
            autoSend: "Auto-send",
            thresholdDays: "Stall threshold",
            daysOption: "{{days}} days",
            sendAt: "Send time (KST)",
            save: "Save settings",
            sendNow: "Send now",
            saved: "Settings saved.",
            saveFailed: "Failed to save settings.",
            sendSent: "Sent {{n}} deals to {{recipients}} admins.",
            sendSkipped: "No deals to review.",
            sendFailed: "Failed to send email.",
            lastRun: "Last automatic send",
            lastRunCount: "{{n}} deals",
            never: "No send history",
            on: "On",
            off: "Off",
            autoAlert: "Auto alert",
            statusOn: "On",
            statusOff: "Off",
            details: "Details",
            turnedOn: "Auto alert turned on.",
            turnedOff: "Auto alert turned off.",
            activeSummary: "Idle {{days}}d+ · daily {{time}}",
            saveHint:
              "Change the idle threshold or send time, then Save to apply them to the auto alert. Use the toggle above for on/off.",
          },
        },
        empty: "No data.",
        salesReps: {
          title: "Sales reps",
          hint: "When you pick a rep in the deal form, name/phone/email are auto-filled.",
          backToAdmin: "Admin home",
          addTitle: "Add sales rep",
          editTitle: "Edit sales rep",
          name: "Name",
          position: "Position",
          phone: "Phone",
          email: "Email",
          actions: "Actions",
          add: "Add",
          edit: "Edit",
          save: "Save",
          cancel: "Cancel",
          delete: "Delete",
          empty: "No sales reps registered yet. Add one above.",
          added: "Sales rep added.",
          updated: "Sales rep updated.",
          deleted: "Sales rep deleted.",
          saveFailed: "Save failed.",
          deleteFailed: "Delete failed.",
          deleteConfirmTitle: "Delete this sales rep?",
          deleteConfirmContent: "Delete '{{name}}'. Sales rep info on existing deals is preserved.",
          deleteConfirmOk: "Delete",
          deleteConfirmCancel: "Cancel",
          selectPlaceholder: "Select a sales rep",
          selectHint: "Phone/email auto-fills when you pick a rep",
          emptyHint: "No sales reps registered yet.",
        },
      },
      auth: {
        guard: {
          loginRequired: "Sign-in required.",
          partnerOnly: "Only approved partners can access this page.",
          adminOnly: "Only administrators can access this page.",
          pendingOnly: "Only sign-up applicants can access this page.",
          sessionExpired: "Your session has expired. Please sign in again.",
        },
      },
      dev: {
        roleSwitcher: {
          label: "Role",
          options: { guest: "Guest", pending: "Pending", partner: "Partner", admin: "Admin" },
          hint: "Dev only (hidden in production)",
        },
      },
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "ko",
  fallbackLng: "ko",
  interpolation: { escapeValue: false },
});

export default i18n;
